

// import React, { useState, useEffect, useRef } from 'react';
// import './Management2.css';
// import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
// import axios from 'axios';
// import { FaSave } from 'react-icons/fa';
// import * as XLSX from 'xlsx';
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// const BasicMenu = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [addedItems, setAddedItems] = useState([]);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [editItem, setEditItem] = useState(null);
//   const [showPopup, setShowPopup] = useState(false);
//   const [image, setImage] = useState(null);
//   const [text, setText] = useState('');
//   const [isVegSelected, setIsVegSelected] = useState(null);
//   const [dishId, setDishId] = useState(null);
//   const [chefType, setChefType] = useState("Chef_South");
//   const [imageFile, setImageFile] = useState(null); // new state for the File
//   const { showLoader, hideLoader } = useLoader();
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchActive, setSearchActive] = useState(false);
//   const handleFilterClick = (tag) => {
//     const vegSelected = tag === 'Veg';
//     setIsVegSelected(vegSelected);
//     applyFilter(data, vegSelected); // apply on existing data
//   };

//   const fileInputRef = useRef(null);

//   const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);

//   const [subDishName, setSubDishName] = useState('');
//   const [price, setPrice] = useState('');
//   const [description, setDescription] = useState('');
//   const [stockQuantity, setStockQuantity] = useState('');
//   const [gst, setGst] = useState('');

//   const [discount, setdiscount] = useState('');
//   const [packingCharges, setPackingCharges] = useState('');
//   const [tag, setTag] = useState('Veg');
//   const [stock, setStock] = useState('In Stock');
//   const [menuStatus, setMenuStatus] = useState(true);
//   const [parentDishDetails, setParentDishDetails] = useState(null);

//   const [filteredData, setFilteredData] = useState([]); // Filtered by tag
//   // const [image, setImage] = useState('');
//   const [showSubEditModal, setShowSubEditModal] = React.useState(false);
//   const [editSubItem, setEditSubItem] = React.useState({
//     dishId: '',
//     subName: '',
//     discount: '',
//     price: '',
//     stockQuantity: '',
//     gst: '',
//     packingCharges: '',
//     image: '',
//     tag: 'Veg', // Add this line
//     chefType: '',
//     parentIndex: null,
//     subIndex: null,
//     description: '',
//   });
//   const normalizeForSearch = (text) => {
//     if (!text) return '';

//     // Convert to lowercase and replace multiple separators with space
//     return text
//       .toLowerCase()
//       .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
//       .trim();
//   };

//   const handleSearch = (query) => {
//     const searchTerm = normalizeForSearch(query);
//     setSearchQuery(query);

//     if (!searchTerm) {
//       setSearchActive(false);
//       applyFilter(data, isVegSelected);
//       return;
//     }

//     setSearchActive(true);

//     // Create search patterns:
//     // 1. Exact match (with spaces normalized)
//     // 2. Without spaces (for "vegmeals")
//     // 3. Individual words
//     const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
//     const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

//     const searchResults = data.map(category => {
//       // Normalize category
//       const normalizedCategory = normalizeForSearch(category.category);
//       const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

//       // Check category matches
//       const categoryMatches =
//         normalizedCategory.includes(searchTerm) ||
//         categoryWithoutSpaces.includes(searchWithoutSpaces) ||
//         searchWords.every(word => normalizedCategory.includes(word));

//       // Filter subcategories
//       const filteredSubcategories = category.subcategories?.filter(sub => {
//         // Normalize subcategory fields
//         const normalizedSubName = normalizeForSearch(sub.subName);
//         const normalizedDescription = normalizeForSearch(sub.description);
//         const normalizedTag = normalizeForSearch(sub.tag);

//         const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
//         const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

//         // Multiple matching strategies
//         const nameMatches =
//           normalizedSubName.includes(searchTerm) ||
//           subNameWithoutSpaces.includes(searchWithoutSpaces) ||
//           searchWords.every(word => normalizedSubName.includes(word));

//         const descMatches =
//           normalizedDescription.includes(searchTerm) ||
//           descWithoutSpaces.includes(searchWithoutSpaces) ||
//           searchWords.every(word => normalizedDescription.includes(word));

//         const tagMatches =
//           normalizedTag.includes(searchTerm) ||
//           normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

//         return nameMatches || descMatches || tagMatches;
//       });

//       // Include category if it matches or has matching subcategories
//       if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
//         return {
//           ...category,
//           subcategories: categoryMatches ? category.subcategories : filteredSubcategories
//         };
//       }

//       return null;
//     }).filter(category => category !== null);

//     setFilteredData(searchResults);
//   };
//   // const applyFilter = (allData, vegOnly) => {
//   //   if (vegOnly === null) {
//   //     setFilteredData(allData); // No filter, show all
//   //     return;
//   //   }

//   //   const filtered = allData.map(category => {
//   //     const filteredSubcategories = category.subcategories.filter(
//   //       sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
//   //     );

//   //     return {
//   //       ...category,
//   //       subcategories: filteredSubcategories
//   //     };
//   //   }).filter(cat => cat.subcategories.length > 0); // only show categories with subcategories

//   //   setFilteredData(filtered);
//   // };
//   const applyFilter = (allData, vegOnly) => {
//     let filtered = allData;

//     // Apply veg filter if selected
//     if (vegOnly !== null) {
//       filtered = allData.map(category => {
//         const filteredSubcategories = category.subcategories.filter(
//           sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
//         );

//         return {
//           ...category,
//           subcategories: filteredSubcategories
//         };
//       }).filter(cat => cat.subcategories.length > 0);
//     }

//     // Apply search if active
//     if (searchActive && searchQuery) {
//       filtered = filtered.map(category => {
//         const categoryMatches = category.category?.toLowerCase().includes(searchQuery);

//         const filteredSubcategories = category.subcategories.filter(sub =>
//           sub.subName?.toLowerCase().includes(searchQuery) ||
//           sub.description?.toLowerCase().includes(searchQuery)
//         );

//         if (categoryMatches || filteredSubcategories.length > 0) {
//           return {
//             ...category,
//             subcategories: categoryMatches ? category.subcategories : filteredSubcategories
//           };
//         }
//         return null;
//       }).filter(category => category !== null);
//     }

//     setFilteredData(filtered);
//   };
//   const [subCategoryData, setSubCategoryData] = React.useState({
//     dishImage: '',
//     // other fields: subDishName, price, tag, stock, menuStatus ...
//   });

//   const containerHeight = window.innerWidth < 768
//     ? '300px'      // Mobile
//     : window.innerWidth < 850
//       ? '300px'  // Below 850px
//       : window.innerWidth < 1350
//         ? '50vh' // Between 850px and 1350px
//         : '510px'; // Desktop

//   const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
//     try {
//       // Optional: Set current dishId
//       setDishId(subDishId);
//       // showLoader();
//       const token = localStorage.getItem("authToken");

//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/dish/get/${subDishId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const subDish = response.data;

//       console.log('Fetched Subcategory Dish:', subDish);

//       setEditSubItem({
//         dishId: subDish.dishId,
//         subName: subDish.dishName || '',
//         price: subDish.price || '',
//         discount: subDish.discount || '',
//         stockQuantity: subDish.stockQuantity || '',
//         gst: subDish.gst || '',
//         packingCharges: subDish.packingCharges || '',
//         image: subDish.dishImage || '',
//         chefType: subDish.chefType || '',
//         tag: subDish.tag || 'Veg', // Add this line
//         parentIndex,
//         subIndex,
//         description: subDish.description || '',
//       });

//       setShowSubEditModal(true);
//     } catch (error) {
//       alert('Error fetching subcategory details:\n' + (error.response?.data?.message || error.message));
//       console.error(error);
//     } finally {
//       // hideLoader();
//     }
//   };

//   const submitEditSubcategory = async () => {
//     if (!editSubItem || !editSubItem.dishId) {
//       alert("Subcategory Dish ID is missing!");
//       return;
//     }

//     try {
//       showLoader();
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         alert("Authentication token not found!");
//         return;
//       }

//       const url = `https://backend.maamaas.com/food/api/dish/edit/${editSubItem.dishId}`;

//       const formData = new FormData();

//       // 1️⃣ JSON data must be sent as a blob with name 'dishData'
//       const dishData = {
//         dishName: editSubItem.subName,
//         price: editSubItem.price,
//         stockQuantity: editSubItem.stockQuantity,
//         gst: editSubItem.gst,
//         packingCharges: editSubItem.packingCharges,
//         discount: editSubItem.discount,
//         tag: editSubItem.tag || 'Veg', // Add this line
//         menuStatus: editSubItem.menuStatus || "Enable", // Add this line
//         description: editSubItem.description,
//       };

//       formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//       // 2️⃣ Image file if selected
//       if (editSubItem.newImageFile) {
//         formData.append("image", editSubItem.newImageFile);
//       }

//       const response = await axios.put(url, formData, {
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       alert("Subcategory updated successfully!");
//       window.location.reload();
//     } catch (error) {
//       console.error("Error updating subcategory:", error);
//       if (error.response) {
//         console.error("Response data:", error.response.data);
//         alert(`Failed to update subcategory: ${error.response.data.message || error.response.data}`);
//       } else {
//         alert(`Failed to update subcategory: ${error.message}`);
//       }
//     } finally {
//       hideLoader();
//     }
//   };


//   const handleAddSubCategory = async (dishId) => {
//     // alert(`Selected dishId: ${dishId}`);

//     const url = `https://backend.maamaas.com/food/api/dish/get/${dishId}`;
//     // console.log('Request URL:', url);

//     const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     try {
//       showLoader();
//       const response = await fetch(url, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`, // ✅ Include token in headers
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const dishData = await response.json();
//       // console.log("Fetched dish data:", dishData);

//       // Set dish data to state for popup
//       setParentDishDetails(dishData);
//       setShowSubcategoryPopup(true);

//     } catch (error) {
//       console.error("Failed to fetch dish data:", error);
//     } finally {
//       hideLoader();
//     }
//   };

//   const handleSubImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImageFile(file); // ✅ Save the file for FormData upload
//       const reader = new FileReader();
//       reader.onloadend = () => setImage(reader.result); // ✅ For preview
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubcategorySubmit = async () => {
//     if (!imageFile) {
//       alert("Please select an image.");
//       return;
//     }

//     const vendorId = localStorage.getItem("vendorId");
//     if (!vendorId) {
//       alert("Vendor ID not found. Please log in again.");
//       return;
//     }

//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     // ✅ Create FormData
//     const formData = new FormData();

//     // Create the JSON part for dishData
//     const dishData = {
//       dishId: 0,
//       price: parseFloat(price) || 0,
//       dishName: subDishName.trim() || "Unnamed Dish",
//       parentId: Number(parentDishDetails?.dishId) || 1,
//       stockQuantity: stockQuantity || 0,
//       gst: gst || 0,
//       packingCharges: packingCharges || 0,
//       discount: discount || 0,
//       tag: tag || "Veg",
//       stock: stock ? "In_Stock" : "Out_of_Stock",
//       menuStatus: menuStatus ? "Enable" : "Disable",
//       description: description?.trim() || "",
//       consumedQuantity: 0,
//       balanceQuantity: 0,
//       effectivePrice: 0,
//       chefType: chefType || "Chef_South"
//     };

//     // Append JSON as a Blob
//     formData.append(
//       "dishData",
//       new Blob([JSON.stringify(dishData)], { type: "application/json" })
//     );

//     // Append image file
//     formData.append("image", imageFile);




//     try {
//       showLoader();
//       const res = await axios.post(
//         `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
//         formData,
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             // ⚠️ Don't set Content-Type manually, axios will handle it
//           },
//         }
//       );

//       alert("Dish added successfully!");
//       window.location.reload();
//       // Reset fields
//       setSubDishName('');
//       setPrice('');
//       setStockQuantity('');
//       setGst('');
//       setPackingCharges('');
//       setTag('Veg');
//       setStock('In Stock');
//       setMenuStatus(true);
//       setSubCategoryData({ dishImage: '' });
//       setdiscount('');
//       setImage(null);
//       setImageFile(null);

//       fetchData();
//     } catch (error) {
//       console.error("❌ Error response:", error.response?.data || error.message);
//       const message =
//         error.response?.data?.error ||
//         error.response?.data?.message ||
//         error.message ||
//         "Unknown error";
//       alert("Upload failed!\n" + message);
//     } finally {
//       hideLoader();
//     }
//   };

//   const handleSave = async () => {
//     if (!text.trim() || !imageFile) {
//       alert("Please provide both the dish name and image.");
//       return;
//     }

//     const vendorId = localStorage.getItem("vendorId");
//     const token = localStorage.getItem("authToken");

//     if (!vendorId) {
//       alert("Vendor ID not found. Please log in again.");
//       return;
//     }

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     try {
//       showLoader();

//       // Create FormData
//       const formData = new FormData();

//       // Dish data (JSON blob)
//       const dishData = {
//         dishId: 0,
//         price: 0,
//         dishName: text.trim(),
//         parentId: 0,
//         stockQuantity: 0,
//         gst: 0,
//         packingCharges: 0,
//       };

//       formData.append(
//         "dishData",
//         new Blob([JSON.stringify(dishData)], { type: "application/json" })
//       );

//       // ✅ Append actual file (binary)
//       formData.append("image", imageFile);

//       // Send request
//       const response = await axios.post(
//         `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       alert("Item added successfully!");
//       setShowPopup(false);
//       setText("");
//       setImage(null);
//       setImageFile(null);
//       window.location.reload();
//     } catch (error) {
//       console.error("Upload failed:", error.response?.data || error.message);
//       alert("Failed to add item: " + (error.response?.data?.message || "Please Uplode Documents"));
//     } finally {
//       hideLoader();
//     }
//   };



//   const handleExport = () => {
//     if (!filteredData || filteredData.length === 0) {
//       alert("No data available to export.");
//       return;
//     }

//     // Prepare export data including subcategories
//     const exportData = [];

//     filteredData.forEach((category, index) => {
//       // Add main category row
//       exportData.push({
//         "S.No": index + 1,
//         "Category": category.category || "",
//         "Subcategory": "",
//         "Price": category.price ? `${category.price}.Rs` : "",
//         "Quantity": category.stockQuantity || "",
//         "Consumed": category.consumedQuantity || "",
//         "Balance": category.balanceQuantity || "",
//         "Tag": category.tag || "",
//         "GST": category.gst ? `${category.gst}%` : "",
//         "Packing": category.packingCharges ? `${category.packingCharges}.Rs` : "",
//         "Chef Type": category.chefType || "",
//         "Item Status": category.menuStatus || "",
//         "Description": category.description || "",
//       });

//       // Add subcategories (if any)
//       if (category.subcategories && category.subcategories.length > 0) {
//         category.subcategories.forEach((sub) => {
//           exportData.push({
//             "S.No": "",
//             "Category": category.category || "",
//             "Subcategory": sub.subName || "",
//             "Price": sub.price ? `${sub.price}.Rs` : "",
//             "Quantity": sub.stockQuantity || "",
//             "Consumed": sub.consumedQuantity || "",
//             "Balance": sub.balanceQuantity || "",
//             "Tag": sub.tag || "",

//             "GST": sub.gst ? `${sub.gst}%` : "",
//             "Packing": sub.packingCharges ? `${sub.packingCharges}.Rs` : "",
//             "Chef Type": sub.chefType || "",
//             "Item Status": sub.menuStatus || "",
//             "Description": sub.description || "",
//           });
//         });
//       }
//     });

//     // Create Excel sheet
//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

//     // Auto-size columns
//     const colWidths = Object.keys(exportData[0]).map((key) => ({
//       wch: Math.max(
//         key.length,
//         ...exportData.map((row) => String(row[key] || "").length)
//       ),
//     }));
//     worksheet["!cols"] = colWidths;

//     // Download Excel file
//     XLSX.writeFile(workbook, "menu_data_export.xlsx");
//   };

//   const handleFileImport = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return alert("Please choose a file.");

//     const vendorId = localStorage.getItem("vendorId");
//     const authToken = localStorage.getItem("authToken");

//     if (!vendorId) return alert("Vendor ID not found in local storage.");
//     if (!authToken) return alert("No auth token found. Please log in first.");

//     // ✅ Prepare FormData for file upload
//     const formData = new FormData();
//     formData.append("file", file); // 👈 must match API’s expected key name

//     try {
//       const response = await axios.post(
//         `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Bearer ${authToken}`,
//           },
//         }
//       );

//       console.log("✅ Import successful:", response.data);
//       alert("✅ Categories imported successfully!");
//       setTimeout(() => window.location.reload(), 1000);

//     } catch (error) {
//       console.error("❌ Import failed:", error);
//       if (error.response) {
//         alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
//       } else {
//         alert("❌ Import failed: Network or unknown error.");
//       }
//     }
//   };

//   const handleEdit = async (id) => {
//     try {
//       setDishId(id); // ✅ now defined properly
//       // hideLoader();
//       const token = localStorage.getItem("authToken");
//       const vendorId = localStorage.getItem("vendorId");
//       if (!token) {
//         alert("Authentication token missing. Please log in again.");
//         return;
//       }
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//         {
//           headers: {
//             "Authorization": `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log("Dish Response Data:", response.data);

//       const dishes = Array.isArray(response.data)
//         ? response.data
//         : response.data.data || [];

//       const dish = dishes.find((d) => d.dishId == id);

//       if (!dish) {
//         alert(`Dish with ID ${id} not found`);
//         return;
//       }

//       setEditItem({
//         dishId: dish.dishId,
//         dishName: dish.dishName || "",
//         image: dish.dishImage || "",
//       });

//       setShowEditModal(true);
//       // window.location.reload();
//     } catch (error) {
//       console.error("Error fetching dish details:", error);
//       alert(
//         "Error fetching dish details:\n" +
//         (error.response?.data?.message || error.message)
//       );
//     } finally {
//       // hideLoader();
//     }
//   };




//   const submitEdit = async () => {
//     if (!editItem.dishId) {
//       alert("Dish ID is missing!");
//       return;
//     }

//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     try {

//       showLoader();
//       const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

//       const formData = new FormData();

//       // JSON data as blob
//       const dishData = {
//         dishName: editItem.dishName,
//       };
//       formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//       // Image file if selected
//       if (editItem.newImageFile) {
//         formData.append("image", editItem.newImageFile);
//       }

//       const response = await axios.put(url, formData, {
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       console.log('Edit successful:', response.data);
//       alert('Dish updated successfully!');
//       window.location.reload();
//       setShowEditModal(false);

//     } catch (error) {
//       console.error("Error updating dish:", error);
//       if (error.response) {
//         console.error("Response data:", error.response.data);
//         alert(`Failed to update dish: ${error.response.data.message || error.response.data}`);
//       } else {
//         alert(`Failed to update dish: ${error.message}`);
//       }
//     } finally {
//       hideLoader();
//     }
//   };


//   const handleEditImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setEditItem(prev => ({
//         ...prev,
//         newImageFile: file,                  // store the file for upload
//         image: URL.createObjectURL(file)     // preview
//       }));
//     }
//   };



//   const fetchData = async () => {
//     const vendorId = localStorage.getItem("vendorId");
//     const token = localStorage.getItem("authToken"); // ✅ Get the token

//     if (!vendorId) {
//       console.warn("⚠️ vendorId not found in localStorage");
//       setError(new Error("vendorId missing"));
//       setLoading(false);
//       return;
//     }

//     if (!token) {
//       console.warn("⚠️ authToken not found in localStorage");
//       setError(new Error("authToken missing"));
//       setLoading(false);
//       return;
//     }

//     try {
//       showLoader();
//       const response = await fetch(
//         `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${token}` // ✅ Include token
//           }
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const dishData = await response.json();

//       const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

//       const formattedData = parentCategories.map(category => {
//         const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

//         return {
//           dishId: category.dishId,
//           SNo: category.dishId,
//           category: category.dishName,
//           image: category.dishImage || '',
//           isChecked: false,
//           parentId: category.parentId,
//           id: category.dishId,
//           isAdded: true,
//           menuStatus: category.menuStatus || "Enable", // Ensure this exists
//           subcategories: subcategories.map(sub => ({
//             dishId: sub.dishId,
//             subName: sub.subName || sub.dishName,
//             price: sub.price,
//             description: sub.description || "",
//             image: sub.dishImage,
//             menuStatus: sub.menuStatus || "Enable",
//             tag: sub.tag || "Veg",
//             stockQuantity: sub.stockQuantity || 0,
//             gst: sub.gst || 0,
//             packingCharges: sub.packingCharges || 0,
//             consumedQuantity: sub.consumedQuantity || 0,
//             balanceQuantity: sub.balanceQuantity || 0,
//             chefType: sub.chefType || 0,
//             discount: sub.discount || 0,
//           }))
//         };
//       });

//       // console.log("Formatted Dish Data:", formattedData);
//       // localStorage.setItem("formattedDishData", JSON.stringify(formattedData));

//       setData(formattedData);
//       applyFilter(formattedData, isVegSelected);

//     } catch (error) {
//       // console.error("Error fetching data:", error);
//       setError(error);
//     } finally {
//       setLoading(false);
//       hideLoader();
//     }
//   };



//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleCheckboxChange = (e, index) => {
//     const { checked } = e.target;
//     setData(prevData => {
//       const updatedData = [...prevData];
//       updatedData[index].isChecked = checked;
//       return updatedData;
//     });
//   };

//   const handleSelectAll = (e) => {
//     const isChecked = e.target.checked;
//     setData(prevData =>
//       prevData.map(item => ({
//         ...item,
//         isChecked: isChecked,
//       }))
//     );
//   };


//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImage(reader.result); // this will include "data:image/...;base64,..."
//       };
//       reader.readAsDataURL(file);
//     }
//   };









//   const handleDeleteRow = async (index, dishId) => {
//     if (!window.confirm("Are you sure you want to delete this dish?")) return;

//     const token = localStorage.getItem("authToken");

//     try {

//       showLoader();
//       const response = await fetch(
//         `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
//         {
//           method: "DELETE",
//           headers: {
//             "Authorization": `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.ok) {
//         alert("Dish deleted successfully!");
//         const newData = data.filter(item => item.SNo !== dishId);
//         setData(newData);
//       } else {
//         const result = await response.json();
//         alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
//       }
//     } catch (error) {
//       alert("An error occurred while deleting.");
//       console.error(error);
//     } finally {
//       hideLoader();
//     }
//   };

//   const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
//     if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

//     const token = localStorage.getItem("authToken");

//     try {
//       showLoader();
//       const response = await fetch(
//         `https://backend.maamaas.com/food/api/dish/delete/${subDishId}`,
//         {
//           method: "DELETE",
//           headers: {
//             "Authorization": `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.ok) {
//         alert("Subcategory deleted successfully!");

//         setData(prevData => {
//           const newData = [...prevData];
//           const updatedSubcategories = [...newData[parentIndex].subcategories];
//           updatedSubcategories.splice(subIndex, 1);
//           newData[parentIndex] = {
//             ...newData[parentIndex],
//             subcategories: updatedSubcategories,
//           };
//           return newData;
//         });
//       } else {
//         const result = await response.json();
//         alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
//       }
//     } catch (error) {
//       alert("An error occurred while deleting the subcategory.");
//       console.error(error);
//     } finally {
//       hideLoader();
//     }
//   };

//   const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {

//     const vendorId = localStorage.getItem("vendorId");
//     const authToken = localStorage.getItem("authToken");

//     if (!vendorId || !authToken) {
//       alert("Authentication failed. Please login again.");
//       return;
//     }

//     const isCategory = (subIndex === null || subIndex === undefined);
//     const newStatus = currentStatus === "Enable" ? "Disable" : "Enable";

//     // ✅ FIX: Update local state IMMEDIATELY
//     if (isCategory) {
//       // For category: Update category and all its subcategories
//       setData(prevData => {
//         const updatedData = [...prevData];
//         updatedData[index] = {
//           ...updatedData[index],
//           menuStatus: newStatus,
//           subcategories: updatedData[index].subcategories.map(sub => ({
//             ...sub,
//             menuStatus: newStatus
//           }))
//         };
//         return updatedData;
//       });

//       // Also update filteredData immediately
//       setFilteredData(prevData => {
//         const updatedData = [...prevData];
//         updatedData[index] = {
//           ...updatedData[index],
//           menuStatus: newStatus,
//           subcategories: updatedData[index].subcategories.map(sub => ({
//             ...sub,
//             menuStatus: newStatus
//           }))
//         };
//         return updatedData;
//       });
//     } else {
//       // For subcategory
//       setData(prevData => {
//         const updatedData = [...prevData];
//         updatedData[index].subcategories[subIndex] = {
//           ...updatedData[index].subcategories[subIndex],
//           menuStatus: newStatus
//         };
//         return updatedData;
//       });

//       setFilteredData(prevData => {
//         const updatedData = [...prevData];
//         updatedData[index].subcategories[subIndex] = {
//           ...updatedData[index].subcategories[subIndex],
//           menuStatus: newStatus
//         };
//         return updatedData;
//       });
//     }

//     // Make API call
//     try {
//       const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
//       const payload = { menuStatus: newStatus };

//       await axios.put(url, payload, {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${authToken}`,
//         },
//       });


//       // If category, update all subcategories too
//       if (isCategory) {
//         const category = data[index];
//         if (category.subcategories && category.subcategories.length > 0) {
//           for (const sub of category.subcategories) {
//             const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
//             const subPayload = { menuStatus: newStatus };

//             await axios.put(subUrl, subPayload, {
//               headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${authToken}`,
//               },
//             });
//           }
//         }
//       }

//       localStorage.setItem(`menuStatus-${dishId}`, newStatus);

//     } catch (error) {
//       console.error('❌ Failed to toggle menu visibility:', error);
//       alert('Failed to update menu visibility. Please refresh the page.');

//       // Revert on error
//       if (isCategory) {
//         setData(prevData => {
//           const updatedData = [...prevData];
//           updatedData[index] = {
//             ...updatedData[index],
//             menuStatus: currentStatus,
//             subcategories: updatedData[index].subcategories.map(sub => ({
//               ...sub,
//               menuStatus: sub.menuStatus
//             }))
//           };
//           return updatedData;
//         });
//       }
//     }
//   };

//   const handleInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setData(prevData => {
//       const updatedData = [...prevData];
//       updatedData[index][name] = value;
//       return updatedData;
//     });
//   };


//   const modalStyle = {
//     position: 'fixed',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     backgroundColor: 'white',
//     padding: '20px',
//     borderRadius: '10px',
//     boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
//     zIndex: 1000,
//     width: '400px', // Define a fixed width for better control over layout
//   };

//   const inputContainerStyle = {
//     marginBottom: '15px',
//   };
//   const inputFieldStyle = {
//     width: '100%',
//     padding: '8px',
//     fontSize: '14px',
//     borderRadius: '5px',
//     border: '1px solid #ddd',
//   };
//   const imagePreviewStyle = {
//     cursor: 'pointer',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     width: '100px',
//     height: '100px',
//     margin: '10px 0',
//     borderRadius: '10px',
//     border: '1px solid #ccc',
//     overflow: 'hidden',
//   };

//   const imageStyle = {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//   };


//   const buttonContainerStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     marginTop: '20px',
//     textAlign: "center"
//   };
//   const closeButtonStyle = {
//     position: 'absolute',
//     top: '10px',
//     right: '10px',
//     cursor: 'pointer',
//   };

//   const closeIconStyle = {
//     fontSize: '24px',
//     fontWeight: 'bold',
//     marginBottom: '30px',
//     color: '#888',
//   };

//   const buttonStyle = {
//     // padding: '10px 20px',
//     height: "32px",
//     backgroundColor: '#b15cd6',
//     color: 'white',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: "bold",
//     marginTop: "10px"
//   };


//   const styles = {
//     overlay: {
//       position: 'fixed',
//       top: 0, left: 0, right: 0, bottom: 0,
//       backgroundColor: 'rgba(0,0,0,0.5)',
//       display: 'flex', alignItems: 'center', justifyContent: 'center',
//       zIndex: 1000,
//     },
//     popup: {
//       background: '#fff',
//       padding: '20px',
//       borderRadius: '8px',
//       width: '300px',
//       boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//       textAlign: 'center',
//     },
//     image: {
//       width: '100%',
//       marginTop: '10px',
//       borderRadius: '5px',
//     },
//     input: {
//       marginTop: '10px',
//       padding: '8px',
//       width: '100%',
//       borderRadius: '5px',
//       border: '1px solid #ccc',
//     },
//     buttons: {
//       marginTop: '15px',
//       display: 'flex',
//       justifyContent: 'center'
//     },
//     saveBtn: {
//       padding: '8px 12px',
//       backgroundColor: '#4CAF50',
//       color: 'white',
//       border: 'none',
//       borderRadius: '5px',
//     },
//     cancelBtn: {
//       padding: '8px 12px',
//       backgroundColor: '#f44336',
//       color: 'white',
//       border: 'none',
//       borderRadius: '5px',
//     }
//   };



//   return (
//     <div style={{ marginTop: "0px" }}>
//       <div style={{ position: 'relative', top: '-11px', }} className='standard-menu'>
//         <style>
//           {`
//                .custom-switch {
//             position: relative;
//             display: inline-block;
//             width: 100px;
//             height: 35px;
//             margin-top:11px;
//           }

//           .custom-switch input {
//             opacity: 0;
//             width: 0;
//             height: 0;
//           }

//           .custom-slider {
//             position: absolute;
//             cursor: pointer;
//             transition: 0.4s;
//             margin-left:-315px;
//             font-weight: bold;
//             font-size: 14px;
//             color: #000;
//             text-align: center;
//             line-height: 35px;
//             width: 100px;
//             height: 40px;
//             border-radius:5px;
//             background-color: rgb(217, 217, 217);
//           }

//    .custom-slider::before {
//   content: "";
//   position: absolute;
//   height: 16px;
//   width: 16px;
//   left: 3px;
//   top: 10px;
//   background-color: #000; /* default */
//   transition: 0.4s;
//   border-radius: 50%;
// }

// .custom-slider.veg::before {
//   background-color: green;
// }

// .custom-slider.non-veg::before {
//   background-color: red;
// }
//         `}
//         </style>



//       </div>

//       <br></br>
//       <div style={{
//         display: 'flex',
//         flexDirection: 'column',
//         marginBottom: '0px',
//         width: '100%',
//         padding: window.innerWidth < 768 ? '0 10px' : '0'
//       }}>
//         {showPopup && (
//           <div style={styles.overlay}>
//             <div style={{
//               ...styles.popup,
//               width: window.innerWidth < 480 ? '280px' : '300px',
//               padding: window.innerWidth < 480 ? '15px' : '20px'
//             }}>
//               <div
//                 style={{
//                   position: "absolute",
//                   fontSize: window.innerWidth < 480 ? "18px" : "20px",
//                   cursor: "pointer",
//                   color: "#888",
//                   fontWeight: "bold",
//                   right: window.innerWidth < 480 ? "10px" : "10px",
//                   top: window.innerWidth < 480 ? "10px" : "10px",
//                   zIndex: 1
//                 }}
//                 onClick={() => setShowPopup(false)}
//               >
//                 ×
//               </div>

//               <h3 style={{
//                 fontSize: window.innerWidth < 480 ? '16px' : '18px',
//                 marginTop: window.innerWidth < 480 ? '5px' : '0'
//               }}>Add Item</h3>

//               <div
//                 style={{
//                   width: "100%",
//                   maxWidth: window.innerWidth < 480 ? "150px" : "175px",
//                   minHeight: window.innerWidth < 480 ? "120px" : "138px",
//                   border: "2px dashed #bbb",
//                   borderRadius: "10px",
//                   margin: "15px auto",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   backgroundColor: "#fafafa",
//                   transition: "border-color 0.3s",
//                 }}
//                 onClick={() => fileInputRef.current?.click()}
//                 onMouseEnter={(e) =>
//                   (e.currentTarget.style.borderColor = "#00b894")
//                 }
//                 onMouseLeave={(e) =>
//                   (e.currentTarget.style.borderColor = "#bbb")
//                 }
//               >
//                 {image ? (
//                   <img
//                     src={image}
//                     alt="Preview"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "contain",
//                       borderRadius: "10px",
//                     }}
//                   />
//                 ) : (
//                   <div
//                     style={{
//                       fontSize: window.innerWidth < 480 ? "40px" : "50px",
//                       color: "#ccc",
//                       fontWeight: "bold",
//                       userSelect: "none",
//                     }}
//                   >
//                     +
//                   </div>
//                 )}
//               </div>

//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept="image/*"
//                 style={{ display: "none" }}
//                 onClick={(e) => {
//                   e.target.value = null;
//                 }}
//                 onChange={(e) => {
//                   const file = e.target.files[0];
//                   if (file) {
//                     setImageFile(file);
//                     const reader = new FileReader();
//                     reader.onloadend = () => setImage(reader.result);
//                     reader.readAsDataURL(file);
//                   }
//                 }}
//               />

//               <input
//                 type="text"
//                 placeholder="Enter Category"
//                 value={text}
//                 onChange={(e) => setText(e.target.value)}
//                 style={{
//                   ...styles.input,
//                   fontSize: window.innerWidth < 480 ? '13px' : '14px',
//                   padding: window.innerWidth < 480 ? '6px 10px' : '8px 12px',
//                   marginTop: window.innerWidth < 480 ? '5px' : '10px'
//                 }}
//               />

//               <div style={{
//                 ...styles.buttons,
//                 marginTop: window.innerWidth < 480 ? '10px' : '15px'
//               }}>
//                 <button onClick={handleSave} style={{
//                   ...styles.saveBtn,
//                   padding: window.innerWidth < 480 ? '6px 12px' : '8px 16px',
//                   fontSize: window.innerWidth < 480 ? '13px' : '14px'
//                 }}>
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Main Controls Container */}
//         <div style={{
//           display: 'flex',
//           flexDirection: window.innerWidth < 768 ? 'column' : 'row',
//           justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
//           alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
//           marginBottom: window.innerWidth < 768 ? '15px' : '0px',
//           gap: window.innerWidth < 768 ? '15px' : '10px',
//           width: '100%',
//           padding: window.innerWidth < 768 ? '0' : '0px'
//         }}>
//           {/* Buttons Group */}
//           <div style={{
//             display: 'flex',
//             flexDirection: 'row',
//             gap: '10px',
//             justifyContent: window.innerWidth < 768 ? 'center' : 'flex-start',
//             alignItems: 'center',
//             flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap',
//             width: window.innerWidth < 768 ? '100%' : 'auto',
//             marginTop: window.innerWidth < 768 ? '0' : '-70px'
//           }}>
//             <input
//               type="file"
//               accept=".xlsx, .xls"
//               ref={fileInputRef}
//               onChange={handleFileImport}
//               style={{ display: 'none' }}
//             />

//             <button
//               style={{
//                 ...importExportButton,
//                 height: window.innerWidth < 480 ? '32px' : '35px',
//                 padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
//                 fontSize: window.innerWidth < 480 ? '0.7rem' : '1rem',
//                 marginTop: window.innerWidth < 768 ? '0' : '10px',
//                 whiteSpace: 'nowrap'
//               }}
//               onClick={() => fileInputRef.current.click()}
//             >
//               Import
//             </button>

//             <button style={{
//               ...importExportButton,
//               height: window.innerWidth < 480 ? '32px' : '35px',
//               padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
//               fontSize: window.innerWidth < 480 ? '0.7rem' : '0.75rem',
//               marginTop: window.innerWidth < 768 ? '0' : '10px',
//               whiteSpace: 'nowrap'
//             }} onClick={handleExport}>
//               Export
//             </button>

//             <button style={{
//               ...importExportButton,
//               height: window.innerWidth < 480 ? '32px' : '35px',
//               padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
//               fontSize: window.innerWidth < 480 ? '0.7rem' : '0.75rem',
//               marginTop: window.innerWidth < 768 ? '0' : '10px',
//               whiteSpace: 'nowrap'
//             }}
//               onClick={() => setShowPopup(true)}
//             >
//               Add Category
//             </button>
//           </div>
//           {/* Search Bar */}
//           <div style={{
//             position: 'relative',
//             width: window.innerWidth < 768 ? '100%' : 'auto',
//             minWidth: window.innerWidth < 480 ? '150px' : '200px',
//             maxWidth: window.innerWidth < 768 ? '100%' : '300px',
//             marginTop: window.innerWidth < 768 ? '0' : '-70px',
//             marginRight: window.innerWidth < 768 ? '0' : '10px',
//             order: window.innerWidth < 768 ? -1 : 0, // Search first on mobile
//             zIndex: 1 // Ensure it's above other elements
//           }}>
//             {/* <input
//               type="text"
//               placeholder="Search dishes or categories..."
//               value={searchQuery}
//               onChange={(e) => {
//                 setSearchQuery(e.target.value);
//                 // Optional: Add debounced search here
//               }}
//               onKeyDown={(e) => {
//                 // Allow all key presses including space
//                 if (e.key === 'Enter') {
//                   handleSearch(searchQuery);
//                 }
//                 // Prevent any default behavior that might block typing
//               }}
//               onKeyUp={(e) => {
//                 // Update search on every keyup (real-time search)
//                 if (e.key !== 'Enter' && e.key !== 'Tab') {
//                   handleSearch(searchQuery);
//                 }
//               }}
//               style={{
//                 width: '100%',
//                 padding: window.innerWidth < 480 ? '6px 35px 6px 10px' : '8px 35px 8px 12px',
//                 borderRadius: '20px',
//                 border: '2px solid #b15cd6',
//                 fontSize: window.innerWidth < 480 ? '13px' : '14px',
//                 outline: 'none',
//                 transition: 'all 0.3s ease',
//                 backgroundColor: '#fff',
//                 height: window.innerWidth < 480 ? '32px' : '35px',
//                 boxSizing: 'border-box',
//                 fontFamily: 'inherit', // Ensure consistent font
//               }}
//               onFocus={(e) => {
//                 e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
//               }}
//               onBlur={(e) => {
//                 e.target.style.boxShadow = 'none';
//               }}
//             />
//             <button
//               onClick={() => handleSearch(searchQuery)}
//               style={{
//                 position: 'absolute',
//                 right: window.innerWidth < 480 ? '6px' : '8px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 background: 'transparent',
//                 border: 'none',
//                 cursor: 'pointer',
//                 padding: '4px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 zIndex: 2
//               }}
//               type="button"
//               aria-label="Search"
//             >
//               <svg
//                 width={window.innerWidth < 480 ? "16" : "18"}
//                 height={window.innerWidth < 480 ? "16" : "18"}
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="#b15cd6"
//                 strokeWidth="2"
//               >
//                 <circle cx="11" cy="11" r="8" />
//                 <path d="m21 21-4.3-4.3" />
//               </svg>
//             </button> */}

//             {/* Add a clear button */}
//             {/* {searchQuery && (
//                             <button
//                                 onClick={() => {
//                                     setSearchQuery("");
//                                     handleSearch("");
//                                 }}
//                                 style={{
//                                     position: 'absolute',
//                                     right: window.innerWidth < 480 ? '28px' : '32px',
//                                     top: '50%',
//                                     transform: 'translateY(-50%)',
//                                     background: 'transparent',
//                                     border: 'none',
//                                     cursor: 'pointer',
//                                     padding: '2px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     color: '#888',
//                                     fontSize: '16px',
//                                     fontWeight: 'bold',
//                                     zIndex: 2
//                                 }}
//                                 type="button"
//                                 aria-label="Clear search"
//                             >
//                                 ×
//                             </button>
//                         )} */}
//           </div>
//         </div>
//       </div>


//       <div style={{
//         overflowX: "auto",       // 👈 enable horizontal scroll
//         overflowY: "scroll",     // 👈 still scrollable vertically
//         height: window.innerHeight < 650 ? " auto" : containerHeight,
//         scrollbarWidthY: "none",
//         maxHeight: window.innerHeight < 450 ? "45vh" : window.innerHeight < 500 ? "50vh" : window.innerHeight < 650 ? "55vh" : window.innerHeight < 700 ? "60vh" : "65vh",
//         // msOverflowStyle: "none", // 👈 hide scrollbar (IE/Edge)
//       }}
//         className="standard-table-data" >



//         {loading ? (
//           <p>Loading data...</p>
//         ) : error ? (
//           <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
//         ) : (
//           <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px", minWidth: "1000px" }}>
//             <thead>
//               <tr style={{ backgroundColor: '#f2f2f2' }}>
//                 <th style={tableHeaderStyle}>S.No</th>
//                 <th style={tableHeaderStyle}>Category</th>
//                 <th style={tableHeaderStyle}>Type</th>
//                 <th style={tableHeaderStyle}>Description</th>
//                 <th style={tableHeaderStyle}>Image</th>
//                 <th style={tableHeaderStyle}>Price</th>
//                 <th style={tableHeaderStyle}>Quantity</th>
//                 <th style={tableHeaderStyle}>Gst</th>
//                 <th style={tableHeaderStyle}>Packing</th>
//                 <th style={tableHeaderStyle}>Discount</th>
//                 <th style={tableHeaderStyle}>Status</th> {/* NEW COLUMN */}
//                 <th style={tableHeaderStyle}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filteredData.map((item, index) => (
//                 <React.Fragment key={index}>
//                   {/* Parent Category Row */}
//                   <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
//                     <td style={tableCellStyle}>{index + 1}</td>
//                     {/* <td style={tableCellStyle}>
//                       <div>
//                         <input
//                           type="text"
//                           name="category"
//                           value={item.category}
//                           onChange={(e) => handleInputChange(e, index)}
//                           style={{ ...inputStyle, fontWeight: 'bold', fontSize: "1rem" }}
//                         />
//                       </div>
//                     </td> */}
//                     <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
//                       {/* <div>
//                         <input
//                           type="text"
//                           name="category"
//                           value={item.category}
//                           onChange={(e) => handleInputChange(e, index)}
//                           style={{ ...inputStyle, fontWeight: 'bold', fontSize: "1rem" }}
//                         />
//                       </div> */}
//                       {item.category}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {item.tag ? item.tag : '-'}
//                     </td>
//                     <td style={tableCellStyle}>
//                       -
//                     </td>
//                     <td style={tableCellStyle}>
//                       <label htmlFor={`fileInput-${index}`} style={{ cursor: 'pointer' }}>
//                         <img
//                           src={item.image}
//                           alt="Dish"
//                           style={{ width: '38px', height: '30px', borderRadius: '10px', marginTop: '-21px' }}
//                         />
//                       </label>
//                       <input
//                         id={`fileInput-${index}`}
//                         type="file"
//                         accept="image/*"
//                         onChange={(e) => handleImageChange(e, index)}
//                         style={{ display: 'none' }}
//                       />
//                     </td>

//                     <td style={tableCellStyle}>
//                       {item.price ? `₹${item.price}` : '-'}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {item.stockQuantity ? `${item.stockQuantity}` : '-'}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {item.gst ? `${item.gst}%` : '-'}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {item.packingCharges ? `₹${item.packingCharges}` : '-'}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {item.discount ? `${item.discount}%` : '-'}
//                     </td>
//                     {/* Status Cell for CATEGORY */}
//                     <td style={tableCellStyle}>
//                       <div style={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '100%'
//                       }}>
//                         <label className="switch">
//                           <input
//                             type="checkbox"
//                             checked={item.menuStatus === "Enable"}  // ✅ Use item.menuStatus directly
//                             onChange={() => handleToggleStatus(index, null, item.dishId, item.menuStatus || "Enable")}
//                           />
//                           <span className="slider round"></span>
//                         </label>
//                         <span
//                           style={{
//                             marginTop: '0.25rem',
//                             color: 'black',
//                             fontSize: '0.9rem',
//                             cursor: 'pointer',
//                             fontWeight: '600'
//                           }}
//                         >
//                           {item.menuStatus === "Enable" ? 'Show' : 'Hide'}
//                         </span>
//                       </div>
//                     </td>
//                     <td style={tableCellStyle}>
//                       <button
//                         style={{
//                           backgroundColor: '#00b894',
//                           color: 'white',
//                           borderRadius: '4px',
//                           padding: '4px 8px',
//                           border: 'none',
//                           cursor: 'pointer',
//                           width: 'fit-content',
//                           marginBottom: '5px'
//                         }}
//                         onClick={() => handleAddSubCategory(item.dishId)}
//                       >
//                         Add
//                       </button>
//                       <button
//                         style={addButtonStyle}
//                         onClick={() => item.isAdded ? handleEdit(item.SNo) : handleSave(item, index)}
//                       >
//                         {item.isAdded ? <FaEdit /> : <FaSave />}
//                       </button>
//                       <button
//                         style={deleteButtonStyle}
//                         onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
//                       >
//                         <FaTrash />
//                       </button>
//                     </td>
//                   </tr>

//                   {/* Subcategories with hierarchical numbering */}
//                   {item.subcategories && item.subcategories.length > 0 && item.subcategories.map((sub, subIndex) => (
//                     <tr key={`sub-${sub.dishId}`} style={{ backgroundColor: '#f9f9f9' }}>
//                       <td style={tableCellStyle}>
//                         {index + 1}.{subIndex + 1}
//                       </td>
//                       <td style={{ ...tableCellStyle, textAlign: "start", fontSize: "0.8rem" }}>↳ {sub.subName}</td>
//                       <td style={tableCellStyle}>
//                         {sub.tag === "Veg" ? (
//                           <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
//                             <div
//                               style={{
//                                 width: "16px",
//                                 height: "16px",
//                                 border: "2px solid green",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 borderRadius: "2px",
//                               }}
//                             >
//                               <div
//                                 style={{
//                                   width: "8px",
//                                   height: "8px",
//                                   backgroundColor: "green",
//                                   borderRadius: "50%",
//                                 }}
//                               ></div>
//                             </div>
//                             <span style={{ color: "green", fontWeight: "500" }}>Veg</span>
//                           </div>
//                         ) : sub.tag === "Non_Veg" ? (
//                           <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
//                             <div
//                               style={{
//                                 width: "16px",
//                                 height: "16px",
//                                 border: "2px solid red",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 borderRadius: "2px",
//                               }}
//                             >
//                               <div
//                                 style={{
//                                   width: "8px",
//                                   height: "8px",
//                                   backgroundColor: "red",
//                                   borderRadius: "50%",
//                                 }}
//                               ></div>
//                             </div>
//                             <span style={{ color: "red", fontWeight: "500" }}>Non-Veg</span>
//                           </div>
//                         ) : (
//                           sub.tag
//                         )}
//                       </td>
//                       <td style={{ ...tableCellStyle, whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '250px', textAlign: 'left' }}>
//                         {sub.description}
//                       </td>
//                       <td style={tableCellStyle}>
//                         <img
//                           src={sub.image}
//                           alt="Sub Dish"
//                           style={{ width: '38px', height: '30px', borderRadius: '10px' }}
//                         />
//                       </td>

//                       <td style={tableCellStyle}>₹{sub.price}</td>
//                       <td style={tableCellStyle}>{sub.stockQuantity}</td>
//                       <td style={tableCellStyle}>
//                         {sub.gst}%
//                       </td>
//                       <td style={tableCellStyle}>
//                         ₹{sub.packingCharges}
//                       </td>
//                       <td style={tableCellStyle}>
//                         {sub.discount}%
//                       </td>
//                       {/* Status Cell for SUBCATEGORY */}
//                       <td style={tableCellStyle}>
//                         <div style={{
//                           display: 'flex',
//                           flexDirection: 'column',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           height: '100%'
//                         }}>
//                           <label className="switch">
//                             <input
//                               type="checkbox"
//                               checked={sub.menuStatus === "Enable"}  // ✅ Use sub.menuStatus directly
//                               onChange={() => handleToggleStatus(index, subIndex, sub.dishId, sub.menuStatus || "Enable")}
//                               disabled={item.menuStatus === "Disable"} // ✅ Disable based on parent status
//                             />
//                             <span className={`slider round ${item.menuStatus === "Disable" ? 'disabled' : ''}`}></span>
//                           </label>
//                           <span
//                             style={{
//                               marginTop: '0.25rem',
//                               color: item.menuStatus === "Disable" ? '#999' : 'black',
//                               fontSize: '0.75rem',
//                               cursor: item.menuStatus === "Disable" ? 'not-allowed' : 'pointer',
//                               fontWeight: '500'
//                             }}
//                           >
//                             {item.menuStatus === "Disable" ? 'Hide' : (sub.menuStatus === "Enable" ? 'Show' : 'Hide')}
//                           </span>
//                         </div>
//                       </td>
//                       <td style={tableCellStyle}>
//                         <div style={{ marginLeft: "10px" }}>
//                           <button
//                             style={addButtonStyle}
//                             onClick={() => handleEditSubcategory(sub.dishId, subIndex, index)}
//                           >
//                             <FaEdit />
//                           </button>
//                           <button
//                             style={deleteButtonStyle}
//                             onClick={() => handleDeleteSubcategory(sub.dishId, subIndex, index)}
//                           >
//                             <FaTrash />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>
//         )}

//       </div>

//       {showEditModal && editItem && (
//         <div style={modalStyle}>
//           <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
//             <span style={closeIconStyle}>×</span> {/* Close icon */}
//           </div>
//           <br></br>
//           {/* <h3 style={{ justifyContent: "center", textAlign: "center", fontWeight: "bold" }}>Edit Dish</h3> */}

//           <div style={inputContainerStyle}>

//             <input
//               id="dishName"
//               type="text"
//               value={editItem.dishName}
//               onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
//               style={inputFieldStyle}
//             />
//           </div>

//           <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
//             <div style={imagePreviewStyle}>
//               <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
//                 <img
//                   src={editItem.image || 'https://via.placeholder.com/100x100'}
//                   alt="Preview"
//                   style={imageStyle}
//                 />
//               </label>

//               <input
//                 id="dishImage"
//                 type="file"
//                 accept="image/*"
//                 onChange={(e) => handleEditImageChange(e)}
//                 style={{ display: 'none' }}
//               />
//             </div>
//           </div>



//           <div style={buttonContainerStyle}>
//             <button onClick={submitEdit} style={buttonStyle}>Update</button>
//           </div>
//         </div>
//       )}



//       {showSubcategoryPopup && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 40,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             backgroundColor: 'rgba(0,0,0,0.6)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000,
//             padding: '20px',
//             boxSizing: 'border-box',
//           }}
//         >
//           <div
//             style={{
//               height: "77vh",
//               overflow: "auto",
//               position: 'relative',  // needed for close icon positioning
//               backgroundColor: '#fff',
//               padding: '30px 25px',
//               borderRadius: '12px',
//               width: '400px',
//               maxWidth: '95%',
//               boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '15px',
//               fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//             }}
//           >
//             {/* Close Icon */}
//             <div
//               onClick={() => setShowSubcategoryPopup(false)}
//               style={{
//                 position: 'absolute',
//                 top: '15px',
//                 right: '15px',
//                 fontSize: '22px',
//                 fontWeight: '700',
//                 color: '#999',
//                 cursor: 'pointer',
//                 userSelect: 'none',
//                 transition: 'color 0.3s',
//               }}
//               onMouseEnter={e => (e.currentTarget.style.color = '#00b894')}
//               onMouseLeave={e => (e.currentTarget.style.color = '#999')}
//               aria-label="Close popup"
//               title="Close"
//             >
//               &times;
//             </div>

//             <h3 style={{ margin: 0, fontWeight: '600', fontSize: '1.3rem', color: '#333' }}>
//               Add Subcategory for: <span style={{ color: '#00b894' }}>{parentDishDetails?.dishName}</span>
//             </h3>

//             <input
//               type="text"
//               value={subDishName}
//               onChange={(e) => setSubDishName(e.target.value)}
//               placeholder="Subcategory Dish Name"
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             />

//             <input
//               type="number"
//               value={price}
//               onChange={(e) => setPrice(e.target.value)}
//               placeholder="Price"
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             />
//             <input
//               type="number"
//               value={stockQuantity}
//               onChange={(e) => setStockQuantity(e.target.value)}
//               placeholder="Quantity"
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             />

//             <input
//               type="number"
//               value={gst}
//               onChange={(e) => setGst(e.target.value)}
//               placeholder="gst"
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             />
//             <input
//               type="number"
//               value={discount}
//               onChange={(e) => setdiscount(e.target.value)}
//               placeholder="discount"
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             />

//             <input
//               type="number"
//               value={packingCharges}
//               onChange={(e) => setPackingCharges(e.target.value)}
//               placeholder="packingcharges"
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             />



//             <select
//               value={tag}
//               onChange={(e) => setTag(e.target.value)}
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//                 backgroundColor: '#fff',
//                 cursor: 'pointer',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             >
//               <option value="Veg">Veg</option>
//               <option value="Non_Veg">Non Veg</option>
//             </select>

//             <select
//               value={stock}
//               onChange={(e) => setStock(e.target.value)}
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//                 backgroundColor: '#fff',
//                 cursor: 'pointer',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             >
//               <option value="In_Stock">In Stock</option>
//               <option value="Out_of_Stock">Out of Stock</option>
//             </select>
//             <input
//               type="text"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               placeholder="Description"
//               style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//               }}
//               onFocus={e => e.target.style.borderColor = '#00b894'}
//               onBlur={e => e.target.style.borderColor = '#ccc'}
//             />

//             <select
//               value={chefType}
//               onChange={(e) => setChefType(e.target.value)} style={{
//                 padding: '10px 12px',
//                 fontSize: '1rem',
//                 borderRadius: '6px',
//                 border: '1.8px solid #ccc',
//                 outline: 'none',
//                 transition: 'border-color 0.3s',
//                 backgroundColor: '#fff',
//                 cursor: 'pointer',
//               }} >
//               {/* <option value="Chef_All">Chef All</option> */}
//               <option value="Chef_North">Chef North</option>
//               <option value="Chef_South">Chef South</option>
//               <option value="Chef_Chinese">Chef Chinese</option>
//               <option value="Chef_Continental">Chef Continental</option>
//               <option value="Tea_stall">Tea Stall</option>
//               <option value="Snacks">Snacks</option>
//               <option value="Bakery">Bakery</option>
//             </select>




//             <div
//               style={{
//                 width: '100%',
//                 maxWidth: '175px',             // optional
//                 minHeight: '138px',
//                 // height: '180px',               // increased height
//                 border: '2px dashed #bbb',
//                 borderRadius: '10px',
//                 margin: '15px auto',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 cursor: 'pointer',
//                 backgroundColor: '#fafafa',
//                 overflow: 'visible',           // ✅ changed from 'hidden' to 'visible'
//                 transition: 'border-color 0.3s',
//               }}
//               onClick={() => document.getElementById('hiddenFileInput').click()}
//               onMouseEnter={e => (e.currentTarget.style.borderColor = '#00b894')}
//               onMouseLeave={e => (e.currentTarget.style.borderColor = '#bbb')}
//             >
//               {image ? (
//                 <img
//                   src={image}
//                   alt="Preview"
//                   style={{
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'contain',       // ✅ changed to 'contain' to avoid distortion/cutoff
//                     borderRadius: '10px',
//                   }}
//                 />
//               ) : (
//                 <div
//                   style={{
//                     fontSize: '50px',
//                     color: '#ccc',
//                     fontWeight: 'bold',
//                     userSelect: 'none',
//                   }}
//                 >
//                   +
//                 </div>
//               )}
//             </div>

//             <input
//               id="hiddenFileInput"
//               type="file"
//               accept="image/*"
//               onChange={handleSubImageChange}
//               style={{ display: 'none' }}
//             />

//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 marginTop: '10px',
//               }}
//             >
//               <button
//                 onClick={handleSubcategorySubmit}
//                 style={{
//                   backgroundColor: '#00b894',
//                   color: 'white',
//                   padding: '10px 20px',
//                   border: 'none',
//                   borderRadius: '6px',
//                   fontWeight: '600',
//                   fontSize: '1rem',
//                   cursor: 'pointer',
//                   transition: 'background-color 0.3s',
//                 }}
//                 onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#019973')}
//                 onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#00b894')}
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {showSubEditModal && (
//         <div style={modalOverlayStyle}>
//           <div style={modalContentStyle}>
//             {/* Close Icon */}
//             <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
//               <button
//                 onClick={() => setShowSubEditModal(false)}
//                 style={{
//                   background: 'transparent',
//                   border: 'none',
//                   fontSize: '20px',
//                   cursor: 'pointer',
//                   color: '#888',
//                 }}
//               >
//                 &times;
//               </button>
//             </div>

//             <h2 style={{ textAlign: 'center', marginBottom: '20px', whiteSpace: "nowrap" }}>Edit Subcategory</h2>

//             {/* Dish Name */}
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 Dish Name:
//               </label>
//               <input
//                 type="text"
//                 value={editSubItem.subName}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 Discription :
//               </label>
//               <input
//                 type="text"
//                 value={editSubItem.description}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, description: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                 }}
//               />
//             </div>

//             {/* Add this dropdown after the Dish Name field */}
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 Dish Type:
//               </label>
//               <select
//                 value={editSubItem.tag || 'Veg'}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, tag: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                   backgroundColor: '#fff',
//                   cursor: 'pointer',
//                 }}
//               >
//                 <option value="Veg">Veg</option>
//                 <option value="Non_Veg">Non-Veg</option>
//               </select>
//             </div>

//             {/* Price */}
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 Price:
//               </label>
//               <input
//                 type="number"
//                 value={editSubItem.price}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                 }}
//               />
//             </div>

//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 Stock Quantity:
//               </label>
//               <input
//                 type="number"
//                 value={editSubItem.stockQuantity}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, stockQuantity: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 GST:
//               </label>
//               <input
//                 type="number"
//                 value={editSubItem.gst}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, gst: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 Packing Charges:
//               </label>
//               <input
//                 type="number"
//                 value={editSubItem.packingCharges}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, packingCharges: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                 }}
//               />
//             </div>

//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                 Discount:
//               </label>
//               <input
//                 type="number"
//                 value={editSubItem.discount}
//                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, discount: e.target.value }))}
//                 style={{
//                   width: '100%',
//                   padding: '10px',
//                   borderRadius: '6px',
//                   border: '1px solid #ccc',
//                   fontSize: '14px',
//                 }}
//               />
//             </div>
//             {/* Image Preview and Upload */}
//             <div style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
//               <div style={imagePreviewStyle}>
//                 <label htmlFor="subDishImage" style={{ cursor: 'pointer' }}>
//                   <img
//                     src={editSubItem.image || 'https://via.placeholder.com/100x100'}
//                     alt="Preview"
//                     style={{
//                       width: '100px',
//                       height: '100px',
//                       objectFit: 'cover',
//                       borderRadius: '10px',
//                       border: '1px solid #ccc',
//                     }}
//                   />

//                 </label>
//                 <input
//                   id="subDishImage"
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) =>
//                     setEditSubItem({
//                       ...editSubItem,
//                       newImageFile: e.target.files[0],
//                       image: URL.createObjectURL(e.target.files[0]), // for preview
//                     })
//                   }
//                   style={{ display: 'none' }}
//                 />
//               </div>
//             </div>

//             {/* Save Button */}
//             <div style={{ display: 'flex', justifyContent: 'center' }}>
//               <button onClick={submitEditSubcategory} style={submitButtonStyle}>
//                 update
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>
//         {`
//     .switch {
//       position: relative;
//       display: inline-block;
//       width: 50px;
//       height: 24px;
//     }
    
//     .switch input {
//       opacity: 0;
//       width: 0;
//       height: 0;
//     }
    
//     .slider {
//       position: absolute;
//       cursor: pointer;
//       top: 0;
//       left: 0;
//       right: 0;
//       bottom: 0;
//       background-color: #4CAF50; /* GREEN for Show */
//       transition: .4s;
//       border-radius: 24px;
//     }
    
//     .slider:before {
//       position: absolute;
//       content: "";
//       height: 18px;
//       width: 18px;
//       left: 3px;
//       bottom: 3px;
//       background-color: white;
//       transition: .4s;
//       border-radius: 50%;
//     }
    
//     input:checked + .slider {
//       background-color: #f44336; /* RED for Hide */
//     }
    
//     input:checked + .slider:before {
//       transform: translateX(26px);
//     }
    
//     .slider.round {
//       border-radius: 24px;
//     }
    
//     .slider.round:before {
//       border-radius: 50%;
//     }
    
//     /* Disabled state */
//     input:disabled + .slider {
//       background-color: #ccc;
//       cursor: not-allowed;
//     }
    
//     input:disabled + .slider:before {
//       background-color: #888;
//     }
    
//     .switch.disabled .slider {
//       background-color: #ccc;
//       cursor: not-allowed;
//     }
    
//     .switch.disabled .slider:before {
//       background-color: #888;
//     }
//        /* ItemUpdates-style toggle - Fixed direction */
// .switch {
//     position: relative;
//     display: inline-block;
//     width: 40px;
//     height: 22px;
// }

// .switch input {
//     opacity: 0;
//     width: 0;
//     height: 0;
// }

// .slider {
//     position: absolute;
//     cursor: pointer;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background-color: #f44336; /* RED by default (Hide) */
//     transition: .4s;
//     border-radius: 34px;
// }

// .slider:before {
//     position: absolute;
//     content: "";
//     height: 16px;
//     width: 16px;
//     left: 3px;  /* LEFT position by default */
//     bottom: 3px;
//     background-color: white;
//     transition: .4s;
//     border-radius: 50%;
// }

// /* CHECKED state - Show (GREEN) */
// input:checked + .slider {
//     background-color: #4CAF50; /* GREEN when Show */
// }

// input:checked + .slider:before {
//     transform: translateX(18px); /* Move to RIGHT when Show */
// }

// .slider.round {
//     border-radius: 34px;
// }

// /* Disabled state - Grayed out */
// .slider.disabled {
//     background-color: #cccccc !important;
//     cursor: not-allowed;
// }

// .switch input:disabled + .slider {
//     background-color: #cccccc !important;
//     cursor: not-allowed;
// }

// .switch input:disabled + .slider:before {
//     background-color: #999999 !important;
// }
//   `}
//       </style>

//     </div>
//   );
// };

// const modalOverlayStyle = {
//   position: 'fixed',
//   top: 0, left: 0, right: 0, bottom: 0,
//   backgroundColor: 'rgba(0,0,0,0.5)',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   zIndex: 1000,
//   marginTop: "50px",
// };

// const modalContentStyle = {
//   backgroundColor: 'white',
//   borderRadius: '8px',
//   padding: '20px',
//   width: '300px',
//   boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//   height: "500px",
//   overflow: "auto",

// };

// const cancelButtonStyle = {
//   backgroundColor: '#ccc',
//   border: 'none',
//   padding: '8px 16px',
//   borderRadius: '4px',
//   cursor: 'pointer',
// };

// const submitButtonStyle = {
//   backgroundColor: '#00b894',
//   color: 'white',
//   border: 'none',
//   padding: '8px 16px',
//   borderRadius: '4px',
//   cursor: 'pointer',
// };


// const buttonStyle = {
//   backgroundColor: '#b15cd6',
//   color: 'white',
//   border: 'none',
//   cursor: 'pointer',
//   borderRadius: '5px',
//   width: '100px',
//   fontWeight: "bold"
// };

// const tableHeaderStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
//   fontWeight: '500',
//   backgroundColor: '#b15cd6',
//   color: 'white',
//   fontSize: "1rem",
//   padding: "1rem",
// };

// const tableCellStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
// };

// const evenRowStyle = { backgroundColor: '#fff' };
// const oddRowStyle = { backgroundColor: '#fff' };

// const inputStyle = {
//   // width: '100%',
//   border: 'none',
//   backgroundColor: 'transparent',
//   textAlign: 'center',
// };

// const addButtonStyle = {
//   backgroundColor: '#fff',
//   color: 'green',
//   border: 'none',
//   cursor: 'pointer',
//   borderRadius: '5px',
//   marginRight: '10px',
//   fontSize: "20px"
// };

// const deleteButtonStyle = {
//   backgroundColor: '#fff',
//   color: 'red',
//   border: 'none',
//   cursor: 'pointer',
//   borderRadius: '5px',
//   fontSize: "20px"
// };

// const importExportButton = {
//   height: '35px',
//   marginTop: window.innerWidth <= 768 ? "10px" : "20px",
//   borderRadius: "4px",
//   border: "none",
//   backgroundColor: "#b15cd6",
//   color: "white",
//   fontWeight: 'bold',
//   fontSize: "0.75rem"
// };

// export default BasicMenu;





import React, { useState, useEffect, useRef } from 'react';
import './Management2.css';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { FaSave } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { useLoader } from "../../../../context/LoaderProvider.jsx";
const BasicMenu = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addedItems, setAddedItems] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [image, setImage] = useState(null);
  const [text, setText] = useState('');
  const [isVegSelected, setIsVegSelected] = useState(null);
  const [dishId, setDishId] = useState(null);
  const [chefType, setChefType] = useState("Chef_South");
  const [imageFile, setImageFile] = useState(null); // new state for the File
  const { showLoader, hideLoader } = useLoader();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const handleFilterClick = (tag) => {
    const vegSelected = tag === 'Veg';
    setIsVegSelected(vegSelected);
    applyFilter(data, vegSelected); // apply on existing data
  };

  const fileInputRef = useRef(null);

  const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);

  const [subDishName, setSubDishName] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [stockQuantity, setStockQuantity] = useState('');
  const [gst, setGst] = useState('');

  const [discount, setdiscount] = useState('');
  const [packingCharges, setPackingCharges] = useState('');
  const [tag, setTag] = useState('Veg');
  const [stock, setStock] = useState('In Stock');
  const [menuStatus, setMenuStatus] = useState(true);
  const [parentDishDetails, setParentDishDetails] = useState(null);

  const [filteredData, setFilteredData] = useState([]); // Filtered by tag
  // const [image, setImage] = useState('');
  const [showSubEditModal, setShowSubEditModal] = React.useState(false);
  const [editSubItem, setEditSubItem] = React.useState({
    dishId: '',
    subName: '',
    discount: '',
    price: '',
    stockQuantity: '',
    gst: '',
    packingCharges: '',
    image: '',
    tag: 'Veg', // Add this line
    chefType: '',
    parentIndex: null,
    subIndex: null,
    description: '',
  });
  const normalizeForSearch = (text) => {
    if (!text) return '';

    // Convert to lowercase and replace multiple separators with space
    return text
      .toLowerCase()
      .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
      .trim();
  };

  const handleSearch = (query) => {
    const searchTerm = normalizeForSearch(query);
    setSearchQuery(query);

    if (!searchTerm) {
      setSearchActive(false);
      applyFilter(data, isVegSelected);
      return;
    }

    setSearchActive(true);

    // Create search patterns:
    // 1. Exact match (with spaces normalized)
    // 2. Without spaces (for "vegmeals")
    // 3. Individual words
    const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
    const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

    const searchResults = data.map(category => {
      // Normalize category
      const normalizedCategory = normalizeForSearch(category.category);
      const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

      // Check category matches
      const categoryMatches =
        normalizedCategory.includes(searchTerm) ||
        categoryWithoutSpaces.includes(searchWithoutSpaces) ||
        searchWords.every(word => normalizedCategory.includes(word));

      // Filter subcategories
      const filteredSubcategories = category.subcategories?.filter(sub => {
        // Normalize subcategory fields
        const normalizedSubName = normalizeForSearch(sub.subName);
        const normalizedDescription = normalizeForSearch(sub.description);
        const normalizedTag = normalizeForSearch(sub.tag);

        const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
        const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

        // Multiple matching strategies
        const nameMatches =
          normalizedSubName.includes(searchTerm) ||
          subNameWithoutSpaces.includes(searchWithoutSpaces) ||
          searchWords.every(word => normalizedSubName.includes(word));

        const descMatches =
          normalizedDescription.includes(searchTerm) ||
          descWithoutSpaces.includes(searchWithoutSpaces) ||
          searchWords.every(word => normalizedDescription.includes(word));

        const tagMatches =
          normalizedTag.includes(searchTerm) ||
          normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

        return nameMatches || descMatches || tagMatches;
      });

      // Include category if it matches or has matching subcategories
      if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
        return {
          ...category,
          subcategories: categoryMatches ? category.subcategories : filteredSubcategories
        };
      }

      return null;
    }).filter(category => category !== null);

    setFilteredData(searchResults);
  };
  // const applyFilter = (allData, vegOnly) => {
  //   if (vegOnly === null) {
  //     setFilteredData(allData); // No filter, show all
  //     return;
  //   }

  //   const filtered = allData.map(category => {
  //     const filteredSubcategories = category.subcategories.filter(
  //       sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
  //     );

  //     return {
  //       ...category,
  //       subcategories: filteredSubcategories
  //     };
  //   }).filter(cat => cat.subcategories.length > 0); // only show categories with subcategories

  //   setFilteredData(filtered);
  // };
  const applyFilter = (allData, vegOnly) => {
    let filtered = allData;

    // Apply veg filter if selected
    if (vegOnly !== null) {
      filtered = allData.map(category => {
        const filteredSubcategories = category.subcategories.filter(
          sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
        );

        return {
          ...category,
          subcategories: filteredSubcategories
        };
      }).filter(cat => cat.subcategories.length > 0);
    }

    // Apply search if active
    if (searchActive && searchQuery) {
      filtered = filtered.map(category => {
        const categoryMatches = category.category?.toLowerCase().includes(searchQuery);

        const filteredSubcategories = category.subcategories.filter(sub =>
          sub.subName?.toLowerCase().includes(searchQuery) ||
          sub.description?.toLowerCase().includes(searchQuery)
        );

        if (categoryMatches || filteredSubcategories.length > 0) {
          return {
            ...category,
            subcategories: categoryMatches ? category.subcategories : filteredSubcategories
          };
        }
        return null;
      }).filter(category => category !== null);
    }

    setFilteredData(filtered);
  };
  const [subCategoryData, setSubCategoryData] = React.useState({
    dishImage: '',
    // other fields: subDishName, price, tag, stock, menuStatus ...
  });

  const containerHeight = window.innerWidth < 768
    ? '300px'      // Mobile
    : window.innerWidth < 850
      ? '300px'  // Below 850px
      : window.innerWidth < 1350
        ? '50vh' // Between 850px and 1350px
        : '510px'; // Desktop

  const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
    try {
      // Optional: Set current dishId
      setDishId(subDishId);
      // showLoader();
      const token = localStorage.getItem("authToken");

      const response = await axios.get(
        `https://backend.maamaas.com/food/api/dish/get/${subDishId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const subDish = response.data;

      console.log('Fetched Subcategory Dish:', subDish);

      setEditSubItem({
        dishId: subDish.dishId,
        subName: subDish.dishName || '',
        price: subDish.price || '',
        discount: subDish.discount || '',
        stockQuantity: subDish.stockQuantity || '',
        gst: subDish.gst || '',
        packingCharges: subDish.packingCharges || '',
        image: subDish.dishImage || '',
        chefType: subDish.chefType || '',
        tag: subDish.tag || 'Veg', // Add this line
        chefType: subDish.chefType || '', // Add this line
        parentIndex,
        subIndex,
        description: subDish.description || '',
      });

      setShowSubEditModal(true);
    } catch (error) {
      alert('Error fetching subcategory details:\n' + (error.response?.data?.message || error.message));
      console.error(error);
    } finally {
      // hideLoader();
    }
  };

  const submitEditSubcategory = async () => {
    if (!editSubItem || !editSubItem.dishId) {
      alert("Subcategory Dish ID is missing!");
      return;
    }

    try {
      showLoader();
      const token = localStorage.getItem("authToken");
      if (!token) {
        alert("Authentication token not found!");
        return;
      }

      const url = `https://backend.maamaas.com/food/api/dish/edit/${editSubItem.dishId}`;

      const formData = new FormData();

      // 1️⃣ JSON data must be sent as a blob with name 'dishData'
      const dishData = {
        dishName: editSubItem.subName,
        price: editSubItem.price,
        stockQuantity: editSubItem.stockQuantity,
        gst: editSubItem.gst,
        packingCharges: editSubItem.packingCharges,
        discount: editSubItem.discount,
        tag: editSubItem.tag || 'Veg', // Add this line
        menuStatus: editSubItem.menuStatus || "Enable", // Add this line
        chefType: editSubItem.chefType || 'Chef_South', // Add this line
        description: editSubItem.description,
      };

      formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

      // 2️⃣ Image file if selected
      if (editSubItem.newImageFile) {
        formData.append("image", editSubItem.newImageFile);
      }

      const response = await axios.put(url, formData, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Subcategory updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error updating subcategory:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        alert(`Failed to update subcategory: ${error.response.data.message || error.response.data}`);
      } else {
        alert(`Failed to update subcategory: ${error.message}`);
      }
    } finally {
      hideLoader();
    }
  };


  const handleAddSubCategory = async (dishId) => {
    // alert(`Selected dishId: ${dishId}`);

    const url = `https://backend.maamaas.com/food/api/dish/get/${dishId}`;
    // console.log('Request URL:', url);

    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    try {
      showLoader();
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // ✅ Include token in headers
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const dishData = await response.json();
      // console.log("Fetched dish data:", dishData);

      // Set dish data to state for popup
      setParentDishDetails(dishData);
      setShowSubcategoryPopup(true);

    } catch (error) {
      console.error("Failed to fetch dish data:", error);
    } finally {
      hideLoader();
    }
  };

  const handleSubImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file); // ✅ Save the file for FormData upload
      const reader = new FileReader();
      reader.onloadend = () => setImage(reader.result); // ✅ For preview
      reader.readAsDataURL(file);
    }
  };

  const handleSubcategorySubmit = async () => {
    if (!imageFile) {
      alert("Please select an image.");
      return;
    }

    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) {
      alert("Vendor ID not found. Please log in again.");
      return;
    }

    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    // ✅ Create FormData
    const formData = new FormData();

    // Create the JSON part for dishData
    const dishData = {
      dishId: 0,
      price: parseFloat(price) || 0,
      dishName: subDishName.trim() || "Unnamed Dish",
      parentId: Number(parentDishDetails?.dishId) || 1,
      stockQuantity: stockQuantity || 0,
      gst: gst || 0,
      packingCharges: packingCharges || 0,
      discount: discount || 0,
      tag: tag || "Veg",
      stock: stock ? "In_Stock" : "Out_of_Stock",
      menuStatus: menuStatus ? "Enable" : "Disable",
      description: description?.trim() || "",
      consumedQuantity: 0,
      balanceQuantity: 0,
      effectivePrice: 0,
      chefType: chefType || "Chef_South"
    };

    // Append JSON as a Blob
    formData.append(
      "dishData",
      new Blob([JSON.stringify(dishData)], { type: "application/json" })
    );

    // Append image file
    formData.append("image", imageFile);




    try {
      showLoader();
      const res = await axios.post(
        `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
        formData,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            // ⚠️ Don't set Content-Type manually, axios will handle it
          },
        }
      );

      alert("Dish added successfully!");
      window.location.reload();
      // Reset fields
      setSubDishName('');
      setPrice('');
      setStockQuantity('');
      setGst('');
      setPackingCharges('');
      setTag('Veg');
      setStock('In Stock');
      setMenuStatus(true);
      setSubCategoryData({ dishImage: '' });
      setdiscount('');
      setImage(null);
      setImageFile(null);

      fetchData();
    } catch (error) {
      console.error("❌ Error response:", error.response?.data || error.message);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Unknown error";
      alert("Upload failed!\n" + message);
    } finally {
      hideLoader();
    }
  };

  const handleSave = async () => {
    if (!text.trim() || !imageFile) {
      alert("Please provide both the dish name and image.");
      return;
    }

    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId) {
      alert("Vendor ID not found. Please log in again.");
      return;
    }

    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    try {
      showLoader();

      // Create FormData
      const formData = new FormData();

      // Dish data (JSON blob)
      const dishData = {
        dishId: 0,
        price: 0,
        dishName: text.trim(),
        parentId: 0,
        stockQuantity: 0,
        gst: 0,
        packingCharges: 0,
      };

      formData.append(
        "dishData",
        new Blob([JSON.stringify(dishData)], { type: "application/json" })
      );

      // ✅ Append actual file (binary)
      formData.append("image", imageFile);

      // Send request
      const response = await axios.post(
        `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Item added successfully!");
      setShowPopup(false);
      setText("");
      setImage(null);
      setImageFile(null);
      window.location.reload();
    } catch (error) {
      console.error("Upload failed:", error.response?.data || error.message);
      alert("Failed to add item: " + (error.response?.data?.message || "Please Uplode Documents"));
    } finally {
      hideLoader();
    }
  };



  const handleExport = () => {
    if (!filteredData || filteredData.length === 0) {
      alert("No data available to export.");
      return;
    }

    // Prepare export data including subcategories
    const exportData = [];

    filteredData.forEach((category, index) => {
      // Add main category row
      exportData.push({
        "S.No": index + 1,
        "Category": category.category || "",
        "Subcategory": "",
        "Price": category.price ? `${category.price}.Rs` : "",
        "Quantity": category.stockQuantity || "",
        "Consumed": category.consumedQuantity || "",
        "Balance": category.balanceQuantity || "",
        "Tag": category.tag || "",
        "GST": category.gst ? `${category.gst}%` : "",
        "Packing": category.packingCharges ? `${category.packingCharges}.Rs` : "",
        "Chef Type": category.chefType || "",
        "Item Status": category.menuStatus || "",
        "Description": category.description || "",
      });

      // Add subcategories (if any)
      if (category.subcategories && category.subcategories.length > 0) {
        category.subcategories.forEach((sub) => {
          exportData.push({
            "S.No": "",
            "Category": category.category || "",
            "Subcategory": sub.subName || "",
            "Price": sub.price ? `${sub.price}.Rs` : "",
            "Quantity": sub.stockQuantity || "",
            "Consumed": sub.consumedQuantity || "",
            "Balance": sub.balanceQuantity || "",
            "Tag": sub.tag || "",

            "GST": sub.gst ? `${sub.gst}%` : "",
            "Packing": sub.packingCharges ? `${sub.packingCharges}.Rs` : "",
            "Chef Type": sub.chefType || "",
            "Item Status": sub.menuStatus || "",
            "Description": sub.description || "",
          });
        });
      }
    });

    // Create Excel sheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

    // Auto-size columns
    const colWidths = Object.keys(exportData[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...exportData.map((row) => String(row[key] || "").length)
      ),
    }));
    worksheet["!cols"] = colWidths;

    // Download Excel file
    XLSX.writeFile(workbook, "menu_data_export.xlsx");
  };

  const handleFileImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return alert("Please choose a file.");

    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");

    if (!vendorId) return alert("Vendor ID not found in local storage.");
    if (!authToken) return alert("No auth token found. Please log in first.");

    // ✅ Prepare FormData for file upload
    const formData = new FormData();
    formData.append("file", file); // 👈 must match API’s expected key name

    try {
      const response = await axios.post(
        `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log("✅ Import successful:", response.data);
      alert("✅ Categories imported successfully!");
      setTimeout(() => window.location.reload(), 1000);

    } catch (error) {
      console.error("❌ Import failed:", error);
      if (error.response) {
        alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
      } else {
        alert("❌ Import failed: Network or unknown error.");
      }
    }
  };

  const handleEdit = async (id) => {
    try {
      setDishId(id); // ✅ now defined properly
      // hideLoader();
      const token = localStorage.getItem("authToken");
      const vendorId = localStorage.getItem("vendorId");
      if (!token) {
        alert("Authentication token missing. Please log in again.");
        return;
      }
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Dish Response Data:", response.data);

      const dishes = Array.isArray(response.data)
        ? response.data
        : response.data.data || [];

      const dish = dishes.find((d) => d.dishId == id);

      if (!dish) {
        alert(`Dish with ID ${id} not found`);
        return;
      }

      setEditItem({
        dishId: dish.dishId,
        dishName: dish.dishName || "",
        image: dish.dishImage || "",
      });

      setShowEditModal(true);
      // window.location.reload();
    } catch (error) {
      console.error("Error fetching dish details:", error);
      alert(
        "Error fetching dish details:\n" +
        (error.response?.data?.message || error.message)
      );
    } finally {
      // hideLoader();
    }
  };




  const submitEdit = async () => {
    if (!editItem.dishId) {
      alert("Dish ID is missing!");
      return;
    }

    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    try {

      showLoader();
      const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

      const formData = new FormData();

      // JSON data as blob
      const dishData = {
        dishName: editItem.dishName,
      };
      formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

      // Image file if selected
      if (editItem.newImageFile) {
        formData.append("image", editItem.newImageFile);
      }

      const response = await axios.put(url, formData, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      console.log('Edit successful:', response.data);
      alert('Dish updated successfully!');
      window.location.reload();
      setShowEditModal(false);

    } catch (error) {
      console.error("Error updating dish:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        alert(`Failed to update dish: ${error.response.data.message || error.response.data}`);
      } else {
        alert(`Failed to update dish: ${error.message}`);
      }
    } finally {
      hideLoader();
    }
  };


  const handleEditImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditItem(prev => ({
        ...prev,
        newImageFile: file,                  // store the file for upload
        image: URL.createObjectURL(file)     // preview
      }));
    }
  };



  const fetchData = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken"); // ✅ Get the token

    if (!vendorId) {
      console.warn("⚠️ vendorId not found in localStorage");
      setError(new Error("vendorId missing"));
      setLoading(false);
      return;
    }

    if (!token) {
      console.warn("⚠️ authToken not found in localStorage");
      setError(new Error("authToken missing"));
      setLoading(false);
      return;
    }

    try {
      showLoader();
      const response = await fetch(
        `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}` // ✅ Include token
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const dishData = await response.json();

      const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

      const formattedData = parentCategories.map(category => {
        const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

        return {
          dishId: category.dishId,
          SNo: category.dishId,
          category: category.dishName,
          image: category.dishImage || '',
          isChecked: false,
          parentId: category.parentId,
          id: category.dishId,
          isAdded: true,
          menuStatus: category.menuStatus || "Enable", // Ensure this exists
          subcategories: subcategories.map(sub => ({
            dishId: sub.dishId,
            subName: sub.subName || sub.dishName,
            price: sub.price,
            description: sub.description || "",
            image: sub.dishImage,
            menuStatus: sub.menuStatus || "Enable",
            tag: sub.tag || "Veg",
            stockQuantity: sub.stockQuantity || 0,
            gst: sub.gst || 0,
            packingCharges: sub.packingCharges || 0,
            consumedQuantity: sub.consumedQuantity || 0,
            balanceQuantity: sub.balanceQuantity || 0,
            chefType: sub.chefType || 0,
            discount: sub.discount || 0,
          }))
        };
      });

      // console.log("Formatted Dish Data:", formattedData);
      // localStorage.setItem("formattedDishData", JSON.stringify(formattedData));

      setData(formattedData);
      applyFilter(formattedData, isVegSelected);

    } catch (error) {
      // console.error("Error fetching data:", error);
      setError(error);
    } finally {
      setLoading(false);
      hideLoader();
    }
  };



  useEffect(() => {
    fetchData();
  }, []);

  const handleCheckboxChange = (e, index) => {
    const { checked } = e.target;
    setData(prevData => {
      const updatedData = [...prevData];
      updatedData[index].isChecked = checked;
      return updatedData;
    });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setData(prevData =>
      prevData.map(item => ({
        ...item,
        isChecked: isChecked,
      }))
    );
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // this will include "data:image/...;base64,..."
      };
      reader.readAsDataURL(file);
    }
  };









  const handleDeleteRow = async (index, dishId) => {
    if (!window.confirm("Are you sure you want to delete this dish?")) return;

    const token = localStorage.getItem("authToken");

    try {

      showLoader();
      const response = await fetch(
        `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
        {
          method: "DELETE",
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        alert("Dish deleted successfully!");
        const newData = data.filter(item => item.SNo !== dishId);
        setData(newData);
      } else {
        const result = await response.json();
        alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      alert("An error occurred while deleting.");
      console.error(error);
    } finally {
      hideLoader();
    }
  };

  const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
    if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

    const token = localStorage.getItem("authToken");

    try {
      showLoader();
      const response = await fetch(
        `https://backend.maamaas.com/food/api/dish/delete/${subDishId}`,
        {
          method: "DELETE",
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        alert("Subcategory deleted successfully!");

        setData(prevData => {
          const newData = [...prevData];
          const updatedSubcategories = [...newData[parentIndex].subcategories];
          updatedSubcategories.splice(subIndex, 1);
          newData[parentIndex] = {
            ...newData[parentIndex],
            subcategories: updatedSubcategories,
          };
          return newData;
        });
      } else {
        const result = await response.json();
        alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      alert("An error occurred while deleting the subcategory.");
      console.error(error);
    } finally {
      hideLoader();
    }
  };

  const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {

    const vendorId = localStorage.getItem("vendorId");
    const authToken = localStorage.getItem("authToken");

    if (!vendorId || !authToken) {
      alert("Authentication failed. Please login again.");
      return;
    }

    const isCategory = (subIndex === null || subIndex === undefined);
    const newStatus = currentStatus === "Enable" ? "Disable" : "Enable";

    // ✅ FIX: Update local state IMMEDIATELY
    if (isCategory) {
      // For category: Update category and all its subcategories
      setData(prevData => {
        const updatedData = [...prevData];
        updatedData[index] = {
          ...updatedData[index],
          menuStatus: newStatus,
          subcategories: updatedData[index].subcategories.map(sub => ({
            ...sub,
            menuStatus: newStatus
          }))
        };
        return updatedData;
      });

      // Also update filteredData immediately
      setFilteredData(prevData => {
        const updatedData = [...prevData];
        updatedData[index] = {
          ...updatedData[index],
          menuStatus: newStatus,
          subcategories: updatedData[index].subcategories.map(sub => ({
            ...sub,
            menuStatus: newStatus
          }))
        };
        return updatedData;
      });
    } else {
      // For subcategory
      setData(prevData => {
        const updatedData = [...prevData];
        updatedData[index].subcategories[subIndex] = {
          ...updatedData[index].subcategories[subIndex],
          menuStatus: newStatus
        };
        return updatedData;
      });

      setFilteredData(prevData => {
        const updatedData = [...prevData];
        updatedData[index].subcategories[subIndex] = {
          ...updatedData[index].subcategories[subIndex],
          menuStatus: newStatus
        };
        return updatedData;
      });
    }

    // Make API call
    try {
      const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
      const payload = { menuStatus: newStatus };

      await axios.put(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
      });


      // If category, update all subcategories too
      if (isCategory) {
        const category = data[index];
        if (category.subcategories && category.subcategories.length > 0) {
          for (const sub of category.subcategories) {
            const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
            const subPayload = { menuStatus: newStatus };

            await axios.put(subUrl, subPayload, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
              },
            });
          }
        }
      }

      localStorage.setItem(`menuStatus-${dishId}`, newStatus);

    } catch (error) {
      console.error('❌ Failed to toggle menu visibility:', error);
      alert('Failed to update menu visibility. Please refresh the page.');

      // Revert on error
      if (isCategory) {
        setData(prevData => {
          const updatedData = [...prevData];
          updatedData[index] = {
            ...updatedData[index],
            menuStatus: currentStatus,
            subcategories: updatedData[index].subcategories.map(sub => ({
              ...sub,
              menuStatus: sub.menuStatus
            }))
          };
          return updatedData;
        });
      }
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setData(prevData => {
      const updatedData = [...prevData];
      updatedData[index][name] = value;
      return updatedData;
    });
  };


  const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    width: '400px', // Define a fixed width for better control over layout
  };

  const inputContainerStyle = {
    marginBottom: '15px',
  };
  const inputFieldStyle = {
    width: '100%',
    padding: '8px',
    fontSize: '14px',
    borderRadius: '5px',
    border: '1px solid #ddd',
  };
  const imagePreviewStyle = {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100px',
    height: '100px',
    margin: '10px 0',
    borderRadius: '10px',
    border: '1px solid #ccc',
    overflow: 'hidden',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };


  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    textAlign: "center"
  };
  const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
  };

  const closeIconStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '30px',
    color: '#888',
  };

  const buttonStyle = {
    // padding: '10px 20px',
    height: "32px",
    backgroundColor: '#b15cd6',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: "bold",
    marginTop: "10px"
  };


  const styles = {
    overlay: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000,
    },
    popup: {
      background: '#fff',
      padding: '20px',
      borderRadius: '8px',
      width: '300px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
      textAlign: 'center',
    },
    image: {
      width: '100%',
      marginTop: '10px',
      borderRadius: '5px',
    },
    input: {
      marginTop: '10px',
      padding: '8px',
      width: '100%',
      borderRadius: '5px',
      border: '1px solid #ccc',
    },
    buttons: {
      marginTop: '15px',
      display: 'flex',
      justifyContent: 'center'
    },
    saveBtn: {
      padding: '8px 12px',
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
    },
    cancelBtn: {
      padding: '8px 12px',
      backgroundColor: '#f44336',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
    }
  };



  return (
    <div style={{ marginTop: "0px" }}>
      <div style={{ position: 'relative', top: '-11px', }} className='standard-menu'>
        <style>
          {`
               .custom-switch {
            position: relative;
            display: inline-block;
            width: 100px;
            height: 35px;
            margin-top:11px;
          }

          .custom-switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .custom-slider {
            position: absolute;
            cursor: pointer;
            transition: 0.4s;
            margin-left:-315px;
            font-weight: bold;
            font-size: 14px;
            color: #000;
            text-align: center;
            line-height: 35px;
            width: 100px;
            height: 40px;
            border-radius:5px;
            background-color: rgb(217, 217, 217);
          }

   .custom-slider::before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 3px;
  top: 10px;
  background-color: #000; /* default */
  transition: 0.4s;
  border-radius: 50%;
}

.custom-slider.veg::before {
  background-color: green;
}

.custom-slider.non-veg::before {
  background-color: red;
}
        `}
        </style>



      </div>

      <br></br>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '0px',
        width: '100%',
        padding: window.innerWidth < 768 ? '0 10px' : '0'
      }}>
        {showPopup && (
          <div style={styles.overlay}>
            <div style={{
              ...styles.popup,
              width: window.innerWidth < 480 ? '280px' : '300px',
              padding: window.innerWidth < 480 ? '15px' : '20px'
            }}>
              <div
                style={{
                  position: "absolute",
                  fontSize: window.innerWidth < 480 ? "18px" : "20px",
                  cursor: "pointer",
                  color: "#888",
                  fontWeight: "bold",
                  right: window.innerWidth < 480 ? "10px" : "10px",
                  top: window.innerWidth < 480 ? "10px" : "10px",
                  zIndex: 1
                }}
                onClick={() => setShowPopup(false)}
              >
                ×
              </div>

              <h3 style={{
                fontSize: window.innerWidth < 480 ? '16px' : '18px',
                marginTop: window.innerWidth < 480 ? '5px' : '0'
              }}>Add Item</h3>

              <div
                style={{
                  width: "100%",
                  maxWidth: window.innerWidth < 480 ? "150px" : "175px",
                  minHeight: window.innerWidth < 480 ? "120px" : "138px",
                  border: "2px dashed #bbb",
                  borderRadius: "10px",
                  margin: "15px auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  backgroundColor: "#fafafa",
                  transition: "border-color 0.3s",
                }}
                onClick={() => fileInputRef.current?.click()}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#00b894")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "#bbb")
                }
              >
                {image ? (
                  <img
                    src={image}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "10px",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      fontSize: window.innerWidth < 480 ? "40px" : "50px",
                      color: "#ccc",
                      fontWeight: "bold",
                      userSelect: "none",
                    }}
                  >
                    +
                  </div>
                )}
              </div>

              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onClick={(e) => {
                  e.target.value = null;
                }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setImageFile(file);
                    const reader = new FileReader();
                    reader.onloadend = () => setImage(reader.result);
                    reader.readAsDataURL(file);
                  }
                }}
              />

              <input
                type="text"
                placeholder="Enter Category"
                value={text}
                onChange={(e) => setText(e.target.value)}
                style={{
                  ...styles.input,
                  fontSize: window.innerWidth < 480 ? '13px' : '14px',
                  padding: window.innerWidth < 480 ? '6px 10px' : '8px 12px',
                  marginTop: window.innerWidth < 480 ? '5px' : '10px'
                }}
              />

              <div style={{
                ...styles.buttons,
                marginTop: window.innerWidth < 480 ? '10px' : '15px'
              }}>
                <button onClick={handleSave} style={{
                  ...styles.saveBtn,
                  padding: window.innerWidth < 480 ? '6px 12px' : '8px 16px',
                  fontSize: window.innerWidth < 480 ? '13px' : '14px'
                }}>
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Main Controls Container */}
        <div style={{
          display: 'flex',
          flexDirection: window.innerWidth < 768 ? 'column' : 'row',
          justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
          alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
          marginBottom: window.innerWidth < 768 ? '15px' : '0px',
          gap: window.innerWidth < 768 ? '15px' : '10px',
          width: '100%',
          padding: window.innerWidth < 768 ? '0' : '0px'
        }}>
          {/* Buttons Group */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            justifyContent: window.innerWidth < 768 ? 'center' : 'flex-start',
            alignItems: 'center',
            flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap',
            width: window.innerWidth < 768 ? '100%' : 'auto',
            marginTop: window.innerWidth < 768 ? '0' : '-70px'
          }}>
            <input
              type="file"
              accept=".xlsx, .xls"
              ref={fileInputRef}
              onChange={handleFileImport}
              style={{ display: 'none' }}
            />

            <button
              style={{
                ...importExportButton,
                height: window.innerWidth < 480 ? '32px' : '35px',
                padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
                fontSize: window.innerWidth < 480 ? '0.7rem' : '1rem',
                marginTop: window.innerWidth < 768 ? '0' : '10px',
                whiteSpace: 'nowrap'
              }}
              onClick={() => fileInputRef.current.click()}
            >
              Import
            </button>

            <button style={{
              ...importExportButton,
              height: window.innerWidth < 480 ? '32px' : '35px',
              padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
              fontSize: window.innerWidth < 480 ? '0.7rem' : '0.75rem',
              marginTop: window.innerWidth < 768 ? '0' : '10px',
              whiteSpace: 'nowrap'
            }} onClick={handleExport}>
              Export
            </button>

            <button style={{
              ...importExportButton,
              height: window.innerWidth < 480 ? '32px' : '35px',
              padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
              fontSize: window.innerWidth < 480 ? '0.7rem' : '0.75rem',
              marginTop: window.innerWidth < 768 ? '0' : '10px',
              whiteSpace: 'nowrap'
            }}
              onClick={() => setShowPopup(true)}
            >
              Add Category
            </button>
          </div>
          {/* Search Bar */}
          <div style={{
            position: 'relative',
            width: window.innerWidth < 768 ? '100%' : 'auto',
            minWidth: window.innerWidth < 480 ? '150px' : '200px',
            maxWidth: window.innerWidth < 768 ? '100%' : '300px',
            marginTop: window.innerWidth < 768 ? '0' : '-70px',
            marginRight: window.innerWidth < 768 ? '0' : '10px',
            order: window.innerWidth < 768 ? -1 : 0, // Search first on mobile
            zIndex: 1 // Ensure it's above other elements
          }}>
            {/* <input
              type="text"
              placeholder="Search dishes or categories..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                // Optional: Add debounced search here
              }}
              onKeyDown={(e) => {
                // Allow all key presses including space
                if (e.key === 'Enter') {
                  handleSearch(searchQuery);
                }
                // Prevent any default behavior that might block typing
              }}
              onKeyUp={(e) => {
                // Update search on every keyup (real-time search)
                if (e.key !== 'Enter' && e.key !== 'Tab') {
                  handleSearch(searchQuery);
                }
              }}
              style={{
                width: '100%',
                padding: window.innerWidth < 480 ? '6px 35px 6px 10px' : '8px 35px 8px 12px',
                borderRadius: '20px',
                border: '2px solid #b15cd6',
                fontSize: window.innerWidth < 480 ? '13px' : '14px',
                outline: 'none',
                transition: 'all 0.3s ease',
                backgroundColor: '#fff',
                height: window.innerWidth < 480 ? '32px' : '35px',
                boxSizing: 'border-box',
                fontFamily: 'inherit', // Ensure consistent font
              }}
              onFocus={(e) => {
                e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
              }}
              onBlur={(e) => {
                e.target.style.boxShadow = 'none';
              }}
            />
            <button
              onClick={() => handleSearch(searchQuery)}
              style={{
                position: 'absolute',
                right: window.innerWidth < 480 ? '6px' : '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2
              }}
              type="button"
              aria-label="Search"
            >
              <svg
                width={window.innerWidth < 480 ? "16" : "18"}
                height={window.innerWidth < 480 ? "16" : "18"}
                viewBox="0 0 24 24"
                fill="none"
                stroke="#b15cd6"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              </svg>
            </button> */}

            {/* Add a clear button */}
            {/* {searchQuery && (
                            <button
                                onClick={() => {
                                    setSearchQuery("");
                                    handleSearch("");
                                }}
                                style={{
                                    position: 'absolute',
                                    right: window.innerWidth < 480 ? '28px' : '32px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#888',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    zIndex: 2
                                }}
                                type="button"
                                aria-label="Clear search"
                            >
                                ×
                            </button>
                        )} */}
          </div>
        </div>
      </div>


      <div style={{
        overflowX: "auto",       // 👈 enable horizontal scroll
        overflowY: "scroll",     // 👈 still scrollable vertically
        height: window.innerHeight < 650 ? " auto" : containerHeight,
        scrollbarWidthY: "none",
        maxHeight: window.innerHeight < 450 ? "45vh" : window.innerHeight < 500 ? "50vh" : window.innerHeight < 650 ? "55vh" : window.innerHeight < 700 ? "60vh" : "65vh",
        // msOverflowStyle: "none", // 👈 hide scrollbar (IE/Edge)
      }}
        className="standard-table-data" >



        {loading ? (
          <p>Loading data...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px", minWidth: "1000px" }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={tableHeaderStyle}>S.No</th>
                <th style={tableHeaderStyle}>Category</th>
                <th style={tableHeaderStyle}>Type</th>
                <th style={tableHeaderStyle}>Description</th>
                <th style={tableHeaderStyle}>Image</th>
                <th style={tableHeaderStyle}>Price</th>
                <th style={tableHeaderStyle}>Quantity</th>
                <th style={tableHeaderStyle}>Gst</th>
                <th style={tableHeaderStyle}>Packing</th>
                <th style={tableHeaderStyle}>Discount</th>
                <th style={tableHeaderStyle}>Status</th> {/* NEW COLUMN */}
                <th style={tableHeaderStyle}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((item, index) => (
                <React.Fragment key={index}>
                  {/* Parent Category Row */}
                  <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                    <td style={tableCellStyle}>{index + 1}</td>
                    <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                      {/* <div>
                        <input
                          type="text"
                          name="category"
                          value={item.category}
                          onChange={(e) => handleInputChange(e, index)}
                          style={{ ...inputStyle, fontWeight: 'bold', fontSize: "1rem" }}
                        />
                      </div> */}
                      {item.category}
                    </td>
                    <td style={tableCellStyle}>
                      {item.tag ? item.tag : '-'}
                    </td>
                    <td style={tableCellStyle}>
                      -
                    </td>
                    <td style={tableCellStyle}>
                      <label htmlFor={`fileInput-${index}`} style={{ cursor: 'pointer' }}>
                        <img
                          src={item.image}
                          alt="Dish"
                          style={{ width: '38px', height: '30px', borderRadius: '10px', marginTop: '-21px' }}
                        />
                      </label>
                      <input
                        id={`fileInput-${index}`}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, index)}
                        style={{ display: 'none' }}
                      />
                    </td>

                    <td style={tableCellStyle}>
                      {item.price ? `₹${item.price}` : '-'}
                    </td>
                    <td style={tableCellStyle}>
                      {item.stockQuantity ? `${item.stockQuantity}` : '-'}
                    </td>
                    <td style={tableCellStyle}>
                      {item.gst ? `${item.gst}%` : '-'}
                    </td>
                    <td style={tableCellStyle}>
                      {item.packingCharges ? `₹${item.packingCharges}` : '-'}
                    </td>
                    <td style={tableCellStyle}>
                      {item.discount ? `${item.discount}%` : '-'}
                    </td>
                    {/* Status Cell for CATEGORY */}
                    <td style={tableCellStyle}>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={item.menuStatus === "Enable"}  // ✅ Use item.menuStatus directly
                            onChange={() => handleToggleStatus(index, null, item.dishId, item.menuStatus || "Enable")}
                          />
                          <span className="slider round"></span>
                        </label>
                        <span
                          style={{
                            marginTop: '0.25rem',
                            color: 'black',
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            fontWeight: '600'
                          }}
                        >
                          {item.menuStatus === "Enable" ? 'Show' : 'Hide'}
                        </span>
                      </div>
                    </td>
                    <td style={tableCellStyle}>
                      <button
                        style={{
                          backgroundColor: '#00b894',
                          color: 'white',
                          borderRadius: '4px',
                          padding: '4px 8px',
                          border: 'none',
                          cursor: 'pointer',
                          width: 'fit-content',
                          marginBottom: '5px'
                        }}
                        onClick={() => handleAddSubCategory(item.dishId)}
                      >
                        Add
                      </button>
                      <button
                        style={addButtonStyle}
                        onClick={() => item.isAdded ? handleEdit(item.SNo) : handleSave(item, index)}
                      >
                        {item.isAdded ? <FaEdit /> : <FaSave />}
                      </button>
                      <button
                        style={deleteButtonStyle}
                        onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>

                  {/* Subcategories with hierarchical numbering */}
                  {item.subcategories && item.subcategories.length > 0 && item.subcategories.map((sub, subIndex) => (
                    <tr key={`sub-${sub.dishId}`} style={{ backgroundColor: '#f9f9f9' }}>
                      <td style={tableCellStyle}>
                        {index + 1}.{subIndex + 1}
                      </td>
                      <td style={{ ...tableCellStyle, textAlign: "start", fontSize: "0.8rem" }}>↳ {sub.subName}</td>
                      <td style={tableCellStyle}>
                        {sub.tag === "Veg" ? (
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                border: "2px solid green",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "2px",
                              }}
                            >
                              <div
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "green",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </div>
                            <span style={{ color: "green", fontWeight: "500" }}>Veg</span>
                          </div>
                        ) : sub.tag === "Non_Veg" ? (
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                border: "2px solid red",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "2px",
                              }}
                            >
                              <div
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor: "red",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </div>
                            <span style={{ color: "red", fontWeight: "500" }}>Non-Veg</span>
                          </div>
                        ) : (
                          sub.tag
                        )}
                      </td>
                      <td style={{ ...tableCellStyle, whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '250px', textAlign: 'left' }}>
                        {sub.description}
                      </td>
                      <td style={tableCellStyle}>
                        <img
                          src={sub.image}
                          alt="Sub Dish"
                          style={{ width: '38px', height: '30px', borderRadius: '10px' }}
                        />
                      </td>

                      <td style={tableCellStyle}>₹{sub.price}</td>
                      <td style={tableCellStyle}>{sub.stockQuantity}</td>
                      <td style={tableCellStyle}>
                        {sub.gst}%
                      </td>
                      <td style={tableCellStyle}>
                        ₹{sub.packingCharges}
                      </td>
                      <td style={tableCellStyle}>
                        {sub.discount}%
                      </td>
                      {/* Status Cell for SUBCATEGORY */}
                      <td style={tableCellStyle}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%'
                        }}>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={sub.menuStatus === "Enable"}  // ✅ Use sub.menuStatus directly
                              onChange={() => handleToggleStatus(index, subIndex, sub.dishId, sub.menuStatus || "Enable")}
                              disabled={item.menuStatus === "Disable"} // ✅ Disable based on parent status
                            />
                            <span className={`slider round ${item.menuStatus === "Disable" ? 'disabled' : ''}`}></span>
                          </label>
                          <span
                            style={{
                              marginTop: '0.25rem',
                              color: item.menuStatus === "Disable" ? '#999' : 'black',
                              fontSize: '0.75rem',
                              cursor: item.menuStatus === "Disable" ? 'not-allowed' : 'pointer',
                              fontWeight: '500'
                            }}
                          >
                            {item.menuStatus === "Disable" ? 'Hide' : (sub.menuStatus === "Enable" ? 'Show' : 'Hide')}
                          </span>
                        </div>
                      </td>
                      <td style={tableCellStyle}>
                        <div style={{ marginLeft: "10px" }}>
                          <button
                            style={addButtonStyle}
                            onClick={() => handleEditSubcategory(sub.dishId, subIndex, index)}
                          >
                            <FaEdit />
                          </button>
                          <button
                            style={deleteButtonStyle}
                            onClick={() => handleDeleteSubcategory(sub.dishId, subIndex, index)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        )}

      </div>

      {showEditModal && editItem && (
        <div style={modalStyle}>
          <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
            <span style={closeIconStyle}>×</span> {/* Close icon */}
          </div>
          <br></br>
          {/* <h3 style={{ justifyContent: "center", textAlign: "center", fontWeight: "bold" }}>Edit Dish</h3> */}

          <div style={inputContainerStyle}>

            <input
              id="dishName"
              type="text"
              value={editItem.dishName}
              onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
              style={inputFieldStyle}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
            <div style={imagePreviewStyle}>
              <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
                <img
                  src={editItem.image || 'https://via.placeholder.com/100x100'}
                  alt="Preview"
                  style={imageStyle}
                />
              </label>

              <input
                id="dishImage"
                type="file"
                accept="image/*"
                onChange={(e) => handleEditImageChange(e)}
                style={{ display: 'none' }}
              />
            </div>
          </div>



          <div style={buttonContainerStyle}>
            <button onClick={submitEdit} style={buttonStyle}>Update</button>
          </div>
        </div>
      )}



      {showSubcategoryPopup && (
        <div
          style={{
            position: 'fixed',
            top: 40,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            padding: '20px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              height: "77vh",
              overflow: "auto",
              position: 'relative',  // needed for close icon positioning
              backgroundColor: '#fff',
              padding: '30px 25px',
              borderRadius: '12px',
              width: '400px',
              maxWidth: '95%',
              boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
              display: 'flex',
              flexDirection: 'column',
              gap: '15px',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
          >
            {/* Close Icon */}
            <div
              onClick={() => setShowSubcategoryPopup(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                fontSize: '22px',
                fontWeight: '700',
                color: '#999',
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'color 0.3s',
              }}
              onMouseEnter={e => (e.currentTarget.style.color = '#00b894')}
              onMouseLeave={e => (e.currentTarget.style.color = '#999')}
              aria-label="Close popup"
              title="Close"
            >
              &times;
            </div>

            <h3 style={{ margin: 0, fontWeight: '600', fontSize: '1.3rem', color: '#333' }}>
              Add Subcategory for: <span style={{ color: '#00b894' }}>{parentDishDetails?.dishName}</span>
            </h3>

            <input
              type="text"
              value={subDishName}
              onChange={(e) => setSubDishName(e.target.value)}
              placeholder="Subcategory Dish Name"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="Price"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />
            <input
              type="number"
              value={stockQuantity}
              onChange={(e) => setStockQuantity(e.target.value)}
              placeholder="Quantity"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <input
              type="number"
              value={gst}
              onChange={(e) => setGst(e.target.value)}
              placeholder="gst"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />
            <input
              type="number"
              value={discount}
              onChange={(e) => setdiscount(e.target.value)}
              placeholder="discount"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <input
              type="number"
              value={packingCharges}
              onChange={(e) => setPackingCharges(e.target.value)}
              placeholder="packingcharges"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />



            <select
              value={tag}
              onChange={(e) => setTag(e.target.value)}
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
                backgroundColor: '#fff',
                cursor: 'pointer',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            >
              <option value="Veg">Veg</option>
              <option value="Non_Veg">Non Veg</option>
            </select>

            <select
              value={stock}
              onChange={(e) => setStock(e.target.value)}
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
                backgroundColor: '#fff',
                cursor: 'pointer',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            >
              <option value="In_Stock">In Stock</option>
              <option value="Out_of_Stock">Out of Stock</option>
            </select>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description"
              style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={e => e.target.style.borderColor = '#00b894'}
              onBlur={e => e.target.style.borderColor = '#ccc'}
            />

            <select
              value={chefType}
              onChange={(e) => setChefType(e.target.value)} style={{
                padding: '10px 12px',
                fontSize: '1rem',
                borderRadius: '6px',
                border: '1.8px solid #ccc',
                outline: 'none',
                transition: 'border-color 0.3s',
                backgroundColor: '#fff',
                cursor: 'pointer',
              }} >
              {/* <option value="Chef_All">Chef All</option> */}
              <option value="Chef_North">Chef North</option>
              <option value="Chef_South">Chef South</option>
              <option value="Chef_Chinese">Chef Chinese</option>
              <option value="Chef_Continental">Chef Continental</option>
              <option value="Tea_stall">Tea Stall</option>
              <option value="Snacks">Snacks</option>
              <option value="Bakery">Bakery</option>
            </select>




            <div
              style={{
                width: '100%',
                maxWidth: '175px',             // optional
                minHeight: '138px',
                // height: '180px',               // increased height
                border: '2px dashed #bbb',
                borderRadius: '10px',
                margin: '15px auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                backgroundColor: '#fafafa',
                overflow: 'visible',           // ✅ changed from 'hidden' to 'visible'
                transition: 'border-color 0.3s',
              }}
              onClick={() => document.getElementById('hiddenFileInput').click()}
              onMouseEnter={e => (e.currentTarget.style.borderColor = '#00b894')}
              onMouseLeave={e => (e.currentTarget.style.borderColor = '#bbb')}
            >
              {image ? (
                <img
                  src={image}
                  alt="Preview"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',       // ✅ changed to 'contain' to avoid distortion/cutoff
                    borderRadius: '10px',
                  }}
                />
              ) : (
                <div
                  style={{
                    fontSize: '50px',
                    color: '#ccc',
                    fontWeight: 'bold',
                    userSelect: 'none',
                  }}
                >
                  +
                </div>
              )}
            </div>

            <input
              id="hiddenFileInput"
              type="file"
              accept="image/*"
              onChange={handleSubImageChange}
              style={{ display: 'none' }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '10px',
              }}
            >
              <button
                onClick={handleSubcategorySubmit}
                style={{
                  backgroundColor: '#00b894',
                  color: 'white',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#019973')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#00b894')}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}


      {showSubEditModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            {/* Close Icon */}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowSubEditModal(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#888',
                }}
              >
                &times;
              </button>
            </div>

            <h2 style={{ textAlign: 'center', marginBottom: '20px', whiteSpace: "nowrap" }}>Edit Subcategory</h2>

            {/* Dish Name */}
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Dish Name:
              </label>
              <input
                type="text"
                value={editSubItem.subName}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Discription :
              </label>
              <input
                type="text"
                value={editSubItem.description}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, description: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>

            {/* Add this dropdown after the Dish Name field */}
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Dish Type:
              </label>
              <select
                value={editSubItem.tag || 'Veg'}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, tag: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                  backgroundColor: '#fff',
                  cursor: 'pointer',
                }}
              >
                <option value="Veg">Veg</option>
                <option value="Non_Veg">Non-Veg</option>
              </select>
            </div>

            {/* Add this after the tag dropdown */}
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Chef Type:
              </label>
              <select
                value={editSubItem.chefType || 'Chef_South'}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, chefType: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                  backgroundColor: '#fff',
                  cursor: 'pointer',
                }}
              >
                <option value="Chef_North">Chef North</option>
                <option value="Chef_South">Chef South</option>
                <option value="Chef_Chinese">Chef Chinese</option>
                <option value="Chef_Continental">Chef Continental</option>
                <option value="Tea_stall">Tea Stall</option>
                <option value="Snacks">Snacks</option>
                <option value="Bakery">Bakery</option>
              </select>
            </div>

            {/* Price */}
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Price:
              </label>
              <input
                type="number"
                value={editSubItem.price}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Stock Quantity:
              </label>
              <input
                type="number"
                value={editSubItem.stockQuantity}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, stockQuantity: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                GST:
              </label>
              <input
                type="number"
                value={editSubItem.gst}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, gst: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Packing Charges:
              </label>
              <input
                type="number"
                value={editSubItem.packingCharges}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, packingCharges: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                Discount:
              </label>
              <input
                type="number"
                value={editSubItem.discount}
                onChange={(e) => setEditSubItem((prev) => ({ ...prev, discount: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                }}
              />
            </div>
            {/* Image Preview and Upload */}
            <div style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
              <div style={imagePreviewStyle}>
                <label htmlFor="subDishImage" style={{ cursor: 'pointer' }}>
                  <img
                    src={editSubItem.image || 'https://via.placeholder.com/100x100'}
                    alt="Preview"
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      border: '1px solid #ccc',
                    }}
                  />

                </label>
                <input
                  id="subDishImage"
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setEditSubItem({
                      ...editSubItem,
                      newImageFile: e.target.files[0],
                      image: URL.createObjectURL(e.target.files[0]), // for preview
                    })
                  }
                  style={{ display: 'none' }}
                />
              </div>
            </div>

            {/* Save Button */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button onClick={submitEditSubcategory} style={submitButtonStyle}>
                update
              </button>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
    .switch {
      position: relative;
      display: inline-block;
      width: 50px;
      height: 24px;
    }
    
    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }
    
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #4CAF50; /* GREEN for Show */
      transition: .4s;
      border-radius: 24px;
    }
    
    .slider:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: .4s;
      border-radius: 50%;
    }
    
    input:checked + .slider {
      background-color: #f44336; /* RED for Hide */
    }
    
    input:checked + .slider:before {
      transform: translateX(26px);
    }
    
    .slider.round {
      border-radius: 24px;
    }
    
    .slider.round:before {
      border-radius: 50%;
    }
    
    /* Disabled state */
    input:disabled + .slider {
      background-color: #ccc;
      cursor: not-allowed;
    }
    
    input:disabled + .slider:before {
      background-color: #888;
    }
    
    .switch.disabled .slider {
      background-color: #ccc;
      cursor: not-allowed;
    }
    
    .switch.disabled .slider:before {
      background-color: #888;
    }
       /* ItemUpdates-style toggle - Fixed direction */
.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f44336; /* RED by default (Hide) */
    transition: .4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;  /* LEFT position by default */
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

/* CHECKED state - Show (GREEN) */
input:checked + .slider {
    background-color: #4CAF50; /* GREEN when Show */
}

input:checked + .slider:before {
    transform: translateX(18px); /* Move to RIGHT when Show */
}

.slider.round {
    border-radius: 34px;
}

/* Disabled state - Grayed out */
.slider.disabled {
    background-color: #cccccc !important;
    cursor: not-allowed;
}

.switch input:disabled + .slider {
    background-color: #cccccc !important;
    cursor: not-allowed;
}

.switch input:disabled + .slider:before {
    background-color: #999999 !important;
}
  `}
      </style>

    </div>
  );
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  marginTop: "50px",
};

const modalContentStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '20px',
  width: '300px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  height: "500px",
  overflow: "auto",

};

const cancelButtonStyle = {
  backgroundColor: '#ccc',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '4px',
  cursor: 'pointer',
};

const submitButtonStyle = {
  backgroundColor: '#00b894',
  color: 'white',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '4px',
  cursor: 'pointer',
};


const buttonStyle = {
  backgroundColor: '#b15cd6',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
  borderRadius: '5px',
  width: '100px',
  fontWeight: "bold"
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: '500',
  backgroundColor: '#b15cd6',
  color: 'white',
  fontSize: "1rem",
  padding: "1rem",
};

const tableCellStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
};

const evenRowStyle = { backgroundColor: '#fff' };
const oddRowStyle = { backgroundColor: '#fff' };

const inputStyle = {
  // width: '100%',
  border: 'none',
  backgroundColor: 'transparent',
  textAlign: 'center',
};

const addButtonStyle = {
  backgroundColor: '#fff',
  color: 'green',
  border: 'none',
  cursor: 'pointer',
  borderRadius: '5px',
  marginRight: '10px',
  fontSize: "20px"
};

const deleteButtonStyle = {
  backgroundColor: '#fff',
  color: 'red',
  border: 'none',
  cursor: 'pointer',
  borderRadius: '5px',
  fontSize: "20px"
};

const importExportButton = {
  height: '35px',
  marginTop: window.innerWidth <= 768 ? "10px" : "20px",
  borderRadius: "4px",
  border: "none",
  backgroundColor: "#b15cd6",
  color: "white",
  fontWeight: 'bold',
  fontSize: "0.75rem"
};

export default BasicMenu;
